<script>
  import { authenticate, createByUrlWithThen, getByUrlWithThen } from "./Authenticate.svelte";
  import { get_ip_address_prefix, get_register_url } from "./Urls.svelte";
  import SankeyWrapper from "./SankeyWrapper.svelte";
  import { create_multi_line_chart_dataset, specific_data_all_to_month_with_date_name } from "./OrSixChartUtils.svelte";
  import {
    add_res_partner_to_leads,
    calc_activiti_cat_dict_generic,
    calc_converted,
    calc_new_customers_over_size,
    calc_opportunities_chart,
    calculate_cancelled_subscriptions,
    calculate_herd_coverage,
    calculate_open_opportunities_per_month,
    calculate_powerchart_over_year_ranks,
    count_leas_older_three_days,
    count_opportunities_wit_abschluss_past,
    count_opportunities_without_activity,
    count_opportunities_with_overdue_activity,
    create_bar_chart_dataset,
    create_goals_list_for_sold_list,
    create_leads_tabelle,
    create_list_of_sources,
    create_power_chart_table,
    create_prediction,
    create_res_partner_data_from_all,
    create_table_data_opportunities,
    current_sales_to_target,
    merge_index,
    seperate_per_month,
    to_dict,
  } from "./OrThreeChartUtils.svelte";
  import {
    calc_boli_order_type_per_month,
    calc_boli_reorder_and_new,
    calc_boli_sales_price_null_per_month,
    calc_boli_sales_warranty_goodwill_old_field,
    calc_cust_gauge_values,
    calc_months_from_selected_year,
    calc_new_customers_per_month_linechart_data,
    check_x_team_country_entry_does_entry_belong_to_team,
    date_list_to_month_index_list,
    dict_to_list,
    divide_by,
    filter_for_new_client,
    find_help_text_if_exists,
    get_single_column,
    get_twelfe_previous_months_date,
    power_chart_to_excel,
    set_customer_gauge,
    sleep,
    format_name,
    countries_by_salesteam,
  } from "./Utils.svelte";

  import { onMount } from "svelte";
  import MultiSelect from "svelte-multiselect";
  import SvelteTooltip from "svelte-tooltip";

  import "/static/js/app.js";
  import Table from "./Table.svelte";
  import LineChart from "./LineChart.svelte";
  import CollapsibleSection from "./CollapsibleSection.svelte";
  import CustomLineChart from "./CustomLineChart.svelte";
  import LeafletWorldMapHeat from "./LeafletWorldMapHeat.svelte";

  import Content from "./Content.svelte";
  import Modal from "svelte-simple-modal";

  // import Gauge from './gauge.min.js';
  import jQuery from "jquery";

  window.jQuery = jQuery;
  window.$ = jQuery;

  export let var_authenticate;
  export let p_w;
  export let u_n;
  export let laender_dict;
  export let see_all_in_sales = false;
  export let see_only_marketing;
  export let in_show_marketing_nav_item = false;
  export let in_show_market_nav_item = false;
  export let in_show_management_nav_item = false;
  export let in_show_sales_dashboard = false;
  export let show_main_content = false;
  export let in_show_helptext_id = false;
  let redraw_after_check_ex_sales = true;
  let no_user_found = false;

  export let finished_get_data = false;
  let mein_name = "";

  export let login_isOpen;
  export let login_failed;

  export let different_user_view_u_n;

  let ghais_special_access = false;

  let allow_refresh_list;

  let redraw = false;

  let ex_sales_persons = [];
  let selected_team = false;
  let group_rights = {};
  let individual_rights = false;
  let see_only_map = {};
  let see_individual_countries = {};

  let new_customers_per_month_linechart_data;

  let team_members = [];

  let salesman_selected = [];
  let refresh_finished_text = "";
  let while_refreshing_text = "";

  let is_teamleader = false;

  let list_of_sources = [];
  let list_of_sources_dict = {};

  let selected_from = new Date(2021, 0, 1);
  new Date();

  let over_year_ranks;
  let pcline;
  let show_ph_boli = false;

  let year_buttons = [];
  let current_year_button;

  let first_country_calculation = true;

  let first_sankey = true;

  let sold_enough_clients = false;

  let first_lost_approach;
  let first_lost_analysis;
  let first_lost_offers;
  let first_lost_closing;

  let current_new_clients = 0;
  let yearly_goal_new_clients = 0;

  let global_current_moth_boli_goal = 0;

  let res_partners_all_data_original;

  export let marketing_goals;
  let marketing_goals_sheet;

  let special_access;
  let checked_special_access;
  let has_special_access = false;
  let country_list;
  let country_selected = [];
  export let clv_targets;

  export let activated_all;

  let sold_enough = true;
  let year_filter = "ALL";

  let show_extra_boli_1 = false;
  let show_extra_boli_2 = false;

  let filter_goals_filtered;

  let power_chart_data;
  let power_chart_data_salesman_index;
  let power_chart_data_filtered;
  export let sale_order_all;
  let sale_order_filtered;
  let sale_order_filtered_angebot;
  export let res_partner_all;
  export let marketing_team;
  let res_partner_filtered;
  let mail_activity_all;
  export let crm_lead_all;
  let crm_lead_all_filtered;
  let salesteams_all;
  export let goals_all;
  let cust_goals_all;
  let cust_goals_filtered;
  export let revenue;
  export let aco_cost;
  export let goal_revenue;
  export let monthly_cost;
  let x_team_country_dashboard;

  let updated_goals_all;
  let updated_cust_goals_all;
  let updated_crm_lead;
  let updated_mail_activity;
  let updated_lost_opportunities;
  let updated_res_partner;
  let updated_sale_order;
  let updated_marketingteams;
  let updated_sale_subscription;
  let updated_lost_leads;
  let updated_salesteams;
  let updated_marketing_goals;
  let updated_archived;
  let updated_messenger_res;
  let updated_sales_price_null;
  let updated_activated;
  let updated_revenue;
  let updated_aco_cost;
  let updated_goal_revenue;
  let updated_monthly_cost;
  let updated_clv_targets;
  let updated_power_chart;

  export let helptexts = false;

  let sales_teams_unfiltered = [];

  let opportunities_filtered;
  let opportunities_filtered_new;
  let opportunities_filtered_won;
  let opportunities_filtered_lost;
  let mail_activity_all_filtered;

  let finished_get_power_chart_data;

  let leads_older_three_days = 0;
  export let insights;
  export let messenger_res;

  let herd_coverage_color = "#20d629";
  let herd_coverage_percentage = 0.0;

  let boli_sold_rank = 0;
  let first_visit_rank = 0;
  let calls_rank = 0;

  let more_than_goal = false;

  export let subscription_all;
  let subscription_all_filtered;

  export let lost_opportunities_all;
  let lost_opportunities_filtered;
  export let lost_leads;
  export let archived;

  let sales_price_null_original;
  let sales_price_null;

  let goals_all_data_original_filtered;

  let res_partners_all_data_original_filtered;
  let lead_all_data_original_filtered;
  let account_move_all_data_original_filtered;

  let lead_all_data_original_filtered_per_month;
  let goals_all_data_original_filtered_per_month;

  let res_partners_all_data_original_dict;

  let herd_size_twelfe_months_bar_chart = {};
  let boli_new_reorder_linechart_data;

  let opportunities_wit_abschluss_past_count = 0;
  let opportunities_wit_abschluss_past_list;

  export let opportunities_days_from_create_to_close;

  let sold_boli_sum = 0;

  //Chart Data:
  let power_chart_table;
  let sold_boli_per_month_linechart_data;
  let sold_ph_boli_per_month_linechart_data;
  let sold_boli_per_month_invoiced_linechart_data;
  let boli_price_null_per_month_linechart_data;
  let sold_boli_per_month_angebote_linechart_data;
  let new_customer_herdsize_linechart_data;
  let herd_coverage;
  let converted_line_chart;
  let op_chart;
  let activity_chart;

  let opportunities_wit_abschluss_past_list_table_data;
  let subscriptions_cancelled_chart;
  let leads_older_three_days_table;
  let leads_offen_table;
  let leads_offen_table_cpy_values;
  let new_customer_herdsize_bar_chart;
  let month_keys_chart;
  let activity_chart_won_opportunities;
  let activity_chart_lost_opportunities;
  let world_map_res_partners;

  let disable_current_month = false;
  let months;

  export let opportunities_in_approach = 0;
  export let opportunities_in_analysis = 0;
  export let opportunities_in_offers = 0;
  export let opportunities_in_closing = 0;
  export let opportunities_in_won = 0;

  let customers_per_herdsize;
  let goals_filtered_pie_chart_data;
  let goals_pie_chart_data_current_month;
  let res_partners_all_data_original_filtered_for_table;
  let account_moves_chart_dataset;
  let account_moves_chart_dataset_teams;
  let account_moves_chart_dataset_fiscal_position_id;
  let account_moves_chart_dataset_leadFinder;
  let account_moves_chart_dataset_distributionPartner;
  let opportunities_without_action_list;
  let opportunities_without_action_list_table;
  let opportunities_with_overdue_activity_list;
  let opportunities_with_overdue_activity_list_table;
  let opportunities_without_action_count = 0;
  let opportunities_with_overdue_activity_count = 0;
  let current_month_bar_chart;

  let catch_first_salesman_country = 3;

  let table_alltime_open_opportunities;
  let leads_older_three_days_table_before_last_filter;

  let opportunities_lost_sankey_data;

  export let sold_boluses = 0;

  //  = {
  //   nodes: [
  //     // { id: 'A1', extra:'blah', color: '#25EE37' },
  //     { id: 'Approach', extra:'Approach' },
  //     { id: 'Analysis', extra:'Analysis' },
  //     { id: 'Offer', extra:'Offer' },
  //     { id: 'Closing', extra:'Closing' },
  //     { id: 'Closing', extra:'Closing' },
  //     { id: 'Lost Approach', extra:'Lost' },
  //     { id: 'Lost Analysis' , extra:'Lost'},
  //     { id: 'Lost Offer' , extra:'Lost'},
  //     { id: 'Lost Closing', extra:'Lost' },
  //   ],
  //   links: [
  //     { source: 'Approach', target: 'Analysis', value: 1, color: '#25ff37' },
  //     { source: 'Analysis', target: 'Offer', value: 1 },
  //     { source: 'Offer', target: 'Closing', value: 1 },
  //     { source: 'Closing', target: 'Closing', value: 1 },

  //     { source: 'Approach', target: 'Lost Approach', value: 1 },
  //     { source: 'Analysis', target: 'Lost Analysis', value: 1 },
  //     { source: 'Offer', target: 'Lost Offer', value: 1 },
  //     { source: 'Closing', target: 'Lost Closing', value: 1 },
  //   ],
  // };

  var opts_herdcoverage = {
    angle: -0.2, // The span of the gauge arc
    lineWidth: 0.4, // The line thickness
    radiusScale: 1, // Relative radius
    pointer: {
      length: 0.6, // // Relative to gauge radius
      strokeWidth: 0.035, // The thickness
      color: "#000000", // Fill color
    },
    limitMax: false, // If false, max value increases automatically if value > maxValue
    limitMin: false, // If true, the min value of the gauge will be fixed
    colorStart: "#6FADCF", // Colors
    colorStop: "#8FC0DA", // just experiment with them
    strokeColor: "#E0E0E0", // to see which ones work best for you
    generateGradient: true,
    renderTicks: {
      divisions: 5,
      divWidth: 0.7,
      divLength: 0.7,
      divColor: "#333333",
      subDivisions: 3,
      subLength: 0.5,
      subWidth: 0.3,
      subColor: "#666666",
    },
    highDpiSupport: true, // High resolution support
    staticZones: [
      { strokeStyle: "#F03E3E", min: 0, max: 50 }, // Red from 100 to 130
      { strokeStyle: "#d99011", min: 50, max: 70 },
      { strokeStyle: "#FFDD00", min: 70, max: 80 }, // Yellow
      { strokeStyle: "#30B32D", min: 80, max: 100 }, // Green
    ],
  };

  let power_chart_column_names = [
    "Month",
    "boli sold classic",
    "#rank &#x1F3C6;",
    "boli sold ph",
    "#rank",
    "new customers won",
    "#rank",
    "first visit",
    "#rank &#x1F3C6;",
    "cold visit",
    "#rank",
    "follow up",
    "#rank",
    "customer visit",
    "#rank",
    "calls",
    "#rank &#x1F3C6;",
    "todos",
    "#rank",
    "installations",
    "#rank",
  ];

  let goals_sum = 0;

  //Dropdowns:
  let last_twelfe_month_dropdown;
  let last_twelfe_month_dropdown_selected;

  let currencies_names;

  let fiscal_position_names;

  let prevent_first_auth_event = 1;

  let all_loaded = false;

  let show_inactive_sales = false;

  calc_year_buttons();

  onMount(() => {
    // add_listeners_to_table();
    // window.$('#table_all_button').click(function (e) {
    //   console.log('Alle Partner wieder einblenden');
    //   filter_partner_activated = false;
    //
    // });
  });

  function set_gauge(id, value, config) {
    let target = document.getElementById(id); // your canvas element

    var gauge = new Gauge(target).setOptions(config); // create sexy gauge!
    gauge.maxValue = 100; // set max gauge value
    gauge.setMinValue(0); // Prefer setter over gauge.minValue = 0
    gauge.animationSpeed = 32; // set animation speed (32 is default value)
    gauge.set(value); // set actual value
  }

  function formatDateAndHours(date) {
    if (date) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false, // Use 24-hour format
      };

      return date.toLocaleString("en-US", options);
    } else {
      return "";
    }
  }

  $: {
    goals_all,
      crm_lead_all,
      mail_activity_all,
      subscription_all,
      res_partner_all,
      sale_order_all,
      lost_opportunities_all,
      finished_get_power_chart_data,
      sales_price_null_original,
      salesteams_all,
      messenger_res,
      activated_all,
      marketing_goals,
      cust_goals_all;

    if (false) {
      if (!goals_all) {
        console.log("goals_all NOT SET: ", goals_all);
      }
      if (!crm_lead_all) {
        console.log("crm_lead_all NOT SET: ", crm_lead_all);
      }
      if (!mail_activity_all) {
        console.log("mail_activity_all NOT SET: ", mail_activity_all);
      }
      if (!subscription_all) {
        console.log("subscription_all NOT SET: ", subscription_all);
      }
      if (!res_partner_all) {
        console.log("res_partner_all NOT SET: ", res_partner_all);
      }
      if (!sale_order_all) {
        console.log("sale_order_all NOT SET: ", sale_order_all);
      }
      if (!lost_opportunities_all) {
        console.log("lost_opportunities_all NOT SET: ", lost_opportunities_all);
      }
      if (!finished_get_power_chart_data) {
        console.log("finished_get_power_chart_data NOT SET: ", finished_get_power_chart_data);
      }
      if (!sales_price_null_original) {
        console.log("sales_price_null_original NOT SET: ", sales_price_null_original);
      }
      if (!salesteams_all) {
        console.log("salesteams_all NOT SET: ", salesteams_all);
      }
      if (!messenger_res) {
        console.log("messenger_res NOT SET: ", messenger_res);
      }
      if (!activated_all) {
        console.log("activated_all NOT SET: ", activated_all);
      }
      if (!marketing_goals) {
        console.log("marketing_goals NOT SET: ", marketing_goals);
      }
      if (!cust_goals_all) {
        console.log("cust_goals_all NOT SET: ", cust_goals_all);
      }
    }

    // console.log("goals_all", goals_all)
    // console.log("crm_lead_all", crm_lead_all)
    // console.log('mail_activity_all', mail_activity_all);
    // console.log('subscription_all:', subscription_all);
    // console.log('res_partner_all', res_partner_all);
    // console.log('sale_order_all', sale_order_all);
    // console.log("lost_opportunities_all", lost_opportunities_all)
    // console.log("finished_get_power_chart_data: ", finished_get_power_chart_data)

    if (
      goals_all &&
      crm_lead_all &&
      mail_activity_all &&
      res_partner_all &&
      sale_order_all &&
      finished_get_power_chart_data &&
      lost_opportunities_all &&
      subscription_all &&
      sales_price_null_original &&
      salesteams_all &&
      messenger_res &&
      activated_all &&
      marketing_goals &&
      cust_goals_all
    ) {
      finished_get_data = true;

      all_loaded = true;

      // console.log("goals_all: ", goals_all)
      // console.log("crm_lead_all: ", crm_lead_all)
      // console.log("mail_activity_all: ", mail_activity_all)
      // console.log("res_partner_all: ", res_partner_all)
      // console.log("sale_order_all: ", sale_order_all)
      // console.log("finished_get_power_chart_data: ", finished_get_power_chart_data)
      // console.log("lost_opportunities_all: ", lost_opportunities_all)
      console.log("Daten geladen");
      do_all_calculations();

      refresh_finished_text = "";
    } else {
      console.log("loading...");
    }
  }

  $: {
    var_authenticate;

    console.log("do authentication");

    if (prevent_first_auth_event) {
      // console.log('prevent_first_auth_event: ', prevent_first_auth_event);
      prevent_first_auth_event = prevent_first_auth_event - 1;
    } else {
      console.log("AUTHENTICATE");
      log_auth();
    }
  }

  $: {
    marketing_goals, marketing_goals_sheet;

    if (marketing_goals && marketing_goals_sheet) {
      marketing_goals = marketing_goals.concat(marketing_goals_sheet);
    }
  }

  $: {
    clv_targets, marketing_goals_sheet;

    let clv_targets_category = ["saas_fee", "hw_revenue", "structure_revenue"];
    let clv_target_definition_id = {
      saas_fee: [95, "SaaS Fee"],
      hw_revenue: [96, "Hardware-Revenue"],
      structure_revenue: [97, "Infrastructure-Revenue"],
    };

    if (clv_targets && marketing_goals_sheet) {
      marketing_goals_sheet.forEach((target) => {
        if (target["goal_name"] == "CLV") {
          clv_targets_category.forEach((category) => {
            if (target["challenge_name"].includes(category)) {
              target["closed"] = false;
              target["completeness"] = 0;
              target["definition_id"] = clv_target_definition_id[category];
              target["user_id"] = [131, "Maria Leitner"];
              target["x_studio_ziel"] = target["name"];
              clv_targets.forEach((clv) => {
                if (clv[0].includes(category)) {
                  clv[1] = clv[1].concat(target);
                }
              });
            }
          });
        }
      });
    }
  }

  let salesman_selected_single = [];
  let salesman_selected_single_save;
  let first_time = 1;

  $: {
    show_inactive_sales;

    redraw_after_check_ex_sales = false;
    redraw_after_check_ex_sales = true;

    power_chart_data_salesman_index = power_chart_data_salesman_index;
    team_members = team_members.sort();
  }

  $: {
    salesman_selected_single;

    if (salesman_selected_single) {
      if (salesman_selected_single.length > 0 && first_time) {
        salesman_selected_single_save = salesman_selected_single;
        console.log("salesman_selected_single_save: ", salesman_selected_single_save);
        first_time = first_time - 1;
      }
    }

    // console.log("in $ salesman_selected_single: ", salesman_selected_single)

    if (salesman_selected_single) {
      if (salesman_selected_single.length > 0) {
        // console.log("salesman_selected_single: ", salesman_selected_single)

        if (salesteams_all) {
          if (salesteams_all.length == 0) {
            catch_first_salesman_country = 0;
          }
        }
        salesman_selected = [salesman_selected_single];
      }
    }
  }

  $: {
    salesman_selected, country_selected;

    //Check if a person without special rights (except Country selection)
    if (country_selected.length > 0 && !individual_rights && !see_all_in_sales && salesman_selected.length > 0 && !has_special_access) {
      if (group_rights) {
        if (group_rights[u_n].includes("ALL")) {
          select_all();
        }
      }
    }

    // console.log('first_event: ', first_event);
    // console.log('salesman_selected.length: ', salesman_selected.length);

    if (catch_first_salesman_country > 0) {
      console.log("catch_first_salesman_country: ", catch_first_salesman_country);
      catch_first_salesman_country = catch_first_salesman_country - 1;
    } else {
      if ((salesman_selected || country_selected) && all_loaded) {
        do_all_calculations();
      }
    }
  }

  function find_power_chart_index(data, try_this, name) {
    if (data[try_this]["2020-01"]["name"] == name) {
      console.log("try_this: ", try_this);
      return try_this;
    }

    var index = 0;
    var found_index = -1;
    data.forEach((element) => {
      if (element["2020-01"]["name"] == name) {
        found_index = index;
      }
      index += 1;
    });

    // console.log('found_index: ', found_index);
    return found_index;
  }

  function filter_all() {
    console.log("check filter all");
    console.log("mein_name", mein_name);
    console.log("see_individual_countries", see_individual_countries);
    console.log("salesman_selected_single", salesman_selected_single);
    console.log("salesman_selected", salesman_selected);
    console.log("country_selected", country_selected);
    console.log("selected_team", selected_team);
    console.log("group_rights", group_rights);
    console.log("salesteams_all", salesteams_all);
    if (u_n in see_individual_countries && salesman_selected_single.length == 0) {
      if (country_selected.length == 0) {
        if (JSON.stringify(group_rights) != "{}") {
          country_selected = see_individual_countries[u_n][0];
        } else if (!selected_team) {
          select_all();
        }
        if (selected_team && !group_rights[u_n].includes("ALL")) {
          salesteams_all.forEach((salesteam) => {
            if (salesteam["teamname"] == selected_team) {
              select_team(salesteam["members"], salesteam["teamname"]);
            }
          });
        }
      }
    } else {
      if (!selected_team && salesteams_all.length > 0) {
        selected_team = salesteams_all[0]["teamname"];
      } else if (!selected_team && !JSON.stringify(group_rights) != "{}" && mein_name) {
        salesman_selected_single = mein_name;
      }
    }
    if (salesman_selected.length == 1) {
      var i = 0;
      power_chart_data.forEach((element) => {
        i += 1;
      });

      // console.log('index: ', power_chart_data_salesman_index.indexOf(salesman_selected));
      if (salesman_selected[0] != "Others") {
        console.log("power_chart_data_salesman_index: ", power_chart_data_salesman_index);
        console.log(
          "power_chart_data_salesman_index.indexOf(salesman_selected[0]): ",
          power_chart_data_salesman_index.indexOf(salesman_selected[0])
        );
        let salesman_index = power_chart_data_salesman_index.indexOf(salesman_selected[0]);

        var power_chart_index = find_power_chart_index(power_chart_data, salesman_index, salesman_selected[0]);

        power_chart_data_filtered = power_chart_data[power_chart_index];
      }
      // console.log('power_chart_data_filtered: ', power_chart_data_filtered);
    }

    filter_subscriptions();
    filter_activities();
    filter_sales(sale_order_all);
    filter_res_partner();
    filter_crm_lead();
    filter_lost_opportunities();
    filter_goals();

    // console.log('year_filter: ', year_filter);
    // console.log('res_partner_filtered: ', res_partner_filtered);

    if (year_filter != "ALL") {
      filter_subscriptions_date(year_filter);
      filter_activities_date(year_filter);
      filter_sales_date(year_filter);
      // filter_crm_lead_date(year_filter);
      // filter_res_partner_date_for_worldmap(year_filter)
    }
    if (res_partner_filtered != undefined) {
      world_map_res_partners = filter_res_partner_active_customer(res_partner_filtered);
    }
  }

  // function filter_res_partner_date_for_worldmap(year_filter){
  //   let tmp = [];

  //   console.log("res_partner_filtered: ", res_partner_filtered)

  //   res_partner_filtered.forEach((element) => {
  //     if(element['first_order_date']){

  //       if(year_filter == "ALL"){
  //         tmp.push(element);
  //         return;
  //       }

  //       var year = parseInt(element['first_order_date'].substring(0,4))
  //       if(year<= year_filter){
  //         tmp.push(element);
  //       }
  //     }
  //   });

  //   world_map_res_partners = tmp;
  // }

  function filter_sales_date(year_filter) {
    let tmp = [];

    sale_order_filtered.forEach((element) => {
      if (element["order__date"]) {
        if (element["order__date"].substring(0, 4) == year_filter) {
          tmp.push(element);
        }
      }
    });

    sale_order_filtered = tmp;

    let tmp2 = [];
    sale_order_filtered_angebot.forEach((element) => {
      if (element["order__date"]) {
        if (element["order__date"].substring(0, 4) == year_filter) {
          tmp2.push(element);
        }
      }
    });

    sale_order_filtered_angebot = tmp2;

    let tmp3 = [];
    sales_price_null.forEach((element) => {
      if (element["x_studio_order_date_mw"]) {
        if (element["x_studio_order_date_mw"].substring(0, 4) == year_filter) {
          tmp3.push(element);
        }
      }
    });

    sales_price_null = tmp3;
  }

  function filter_activities_date(year_filter) {
    let tmp = [];

    mail_activity_all_filtered.forEach((element) => {
      if (element["date"]) {
        if (element["date"].substring(0, 4) == year_filter) {
          tmp.push(element);
        }
      }
    });

    mail_activity_all_filtered = tmp;
  }

  function filter_subscriptions_date(year_filter) {
    let tmp = [];

    subscription_all_filtered.forEach((element) => {
      if (element["date"]) {
        if (element["date"].substring(0, 4) == year_filter) {
          tmp.push(element);
        }
      }
    });

    subscription_all_filtered = tmp;
    // console.log('subscription_all_filtered: ', subscription_all_filtered);
  }

  function filter_goals() {
    filter_goals_filtered = [];

    // console.log('x_team_country_dashboard', x_team_country_dashboard);

    goals_all.forEach((element) => {
      // remove goals for HQ because of no target for HQ
      if (selected_team == "smX HQ") {
        return;
      }

      // if (country_selected.length > 0) {
      //   return;
      // }

      if (element["x_studio_ziel"] && element["x_studio_ziel"].includes("SOLD_BOL_TARGET")) {
        return;
      }

      if (element["user_id"]) {
        var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
          false,
          element["user_id"][1],
          salesman_selected,
          x_team_country_dashboard,
          false,
          selected_team,
          element["start_date"],
          true
        );

        if (!does_entry_belong_to_the_team) {
          return;
        }

        filter_goals_filtered.push(element);
      }
    });

    cust_goals_filtered = [];

    cust_goals_all.forEach((element) => {
      // console.log("element: ", element)

      if (country_selected.length > 0) {
        return;
      }

      if (element["user_id"]) {
        if (salesman_selected.includes(element["user_id"][1])) {
          cust_goals_filtered.push(element);
        }
      }
    });
  }

  function filter_lost_opportunities() {
    lost_opportunities_filtered = [];

    // console.log('lost_opportunities_all: ', lost_opportunities_all);

    console.log("lost_opportunities_all: ", lost_opportunities_all);

    lost_opportunities_all.forEach((element) => {
      // if (element['x_name'] == 'Testlead Stefan B') {
      //   console.log('element: ', element);
      // }

      if (country_selected.length > 0) {
        if (!element["country"]) {
          return;
        }
        if (element["country"] != country_selected) {
          return;
        }
      }

      if (element["x_user_id"]) {
        var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
          false,
          element["x_user_id"][1],
          salesman_selected,
          x_team_country_dashboard,
          element["country"],
          selected_team
        );

        //neu:
        if (!does_entry_belong_to_the_team) {
          return;
        }

        // console.log("element: ", element)
        lost_opportunities_filtered.push(element);
      }
    });
    // console.log("lost_opportunities_filtered: ", lost_opportunities_filtered)
  }

  function filter_subscriptions() {
    subscription_all_filtered = [];

    // console.log("subscription_all: ", subscription_all)

    subscription_all.forEach((element) => {
      if (country_selected.length > 0) {
        // console.log("country_selected!!: ", country_selected)
        if (!element[1]["country_id"]) {
          return;
        }
        if (element[1]["country_id"][1] != country_selected) {
          return;
        }
      }

      // console.log("salesman_selected: ", salesman_selected)

      if (element[1]["user_id"]) {
        var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
          false,
          element[1]["user_id"][1],
          salesman_selected,
          x_team_country_dashboard,
          element[1]["country_id"][1],
          selected_team
        );

        //neu:
        if (!does_entry_belong_to_the_team) {
          return;
        }

        subscription_all_filtered.push(element[1]);
      }
    });

    // console.log('subscription_all_filtered: ', subscription_all_filtered);
  }

  function filter_activities() {
    let tmp_list = [];

    mail_activity_all.forEach((element) => {
      if (country_selected.length > 0) {
        if (!element[1]["country_id"]) {
          return;
        }
        if (element[1]["country_id"][1] != country_selected) {
          return;
        }
      }

      if (element[1]["user_id"]) {
        var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
          false,
          element[1]["author"],
          salesman_selected,
          x_team_country_dashboard,
          element[1]["country_id"][1],
          selected_team
        );

        //neu:
        if (!does_entry_belong_to_the_team) {
          return;
        }

        tmp_list.push(element[1]);
      }
    });
    mail_activity_all_filtered = tmp_list;
  }

  function filter_crm_lead() {
    let tmp = [];
    let tmp_opportunity = [];

    let difference_sum = 0;

    //tmp sind leads
    // tmp_opportunity sind opportunities

    opportunities_in_approach = 0;
    opportunities_in_analysis = 0;
    opportunities_in_offers = 0;
    opportunities_in_closing = 0;
    opportunities_in_won = 0;

    if (first_country_calculation) {
      country_list = [];
      first_country_calculation = false;
    }

    let current_month_index;
    if (new Date().getMonth() + 1 < 10) {
      current_month_index = new Date().getFullYear().toString() + "-0" + (new Date().getMonth() + 1).toString();
    } else {
      current_month_index = new Date().getFullYear().toString() + "-" + (new Date().getMonth() + 1).toString();
    }
    // console.log('current_month_index: ', current_month_index);

    // console.log('crm_lead_all: ', crm_lead_all);

    crm_lead_all.forEach((element) => {
      if (country_selected.length > 0) {
        if (!element[1]["country_id"]) {
          return;
        }
        if (element[1]["country_id"][1] != country_selected) {
          return;
        }
      }

      // console.log("element[1]: ", element[1])

      if (!element[1]["user_id"]) {
        return;
      }

      if (element[1]["country_id"]) {
        if (!country_list.includes(element[1]["country_id"][1])) {
          // console.log("zu country hinzufügen!")
          country_list.push(element[1]["country_id"][1]);
        }
      }

      var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
        false,
        element[1]["user_id"][1],
        salesman_selected,
        x_team_country_dashboard,
        element[1]["country_id"][1],
        selected_team
      );

      //alt:
      // if (!salesman_selected.includes(element[1]['user_id'][1])) {
      //   return;
      // }

      //neu:
      if (!does_entry_belong_to_the_team) {
        return;
      }

      if (element[1]["type"] == "lead") {
        tmp.push(element[1]);
      } else {
        tmp_opportunity.push(element[1]);
        if (element[1]["stage_id"]) {
          if (element[1]["stage_id"][1] == "Closing") {
            opportunities_in_closing = opportunities_in_closing + 1;
          }
          if (element[1]["stage_id"][1] == "Gewonnen") {
            opportunities_in_won = opportunities_in_won + 1;

            if (element[1]["date_last_stage_update"]) {
              let date_won = new Date(element[1]["date_last_stage_update"]);
              let date_created = new Date(element[1]["create_date"]);

              var Difference_In_Time = date_won.getTime() - date_created.getTime();

              // To calculate the no. of days between two dates
              var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
              difference_sum = difference_sum + Difference_In_Days;
            }
          }
          if (element[1]["stage_id"][1] == "Approach") {
            opportunities_in_approach = opportunities_in_approach + 1;
          }
          if (element[1]["stage_id"][1] == "Offer") {
            opportunities_in_offers = opportunities_in_offers + 1;
          }
          if (element[1]["stage_id"][1] == "Analysis") {
            opportunities_in_analysis = opportunities_in_analysis + 1;
          }
        }
      }
    });
    opportunities_days_from_create_to_close = (difference_sum / opportunities_in_won).toFixed(2);

    let tmp_opportunity_new = [];
    let tmp_opportunity_won = [];
    let tmp_opportunity_lost = [];

    tmp_opportunity.forEach((element) => {
      if (!element["user_id"]) {
        return;
      }

      if (!salesman_selected.includes(element["user_id"][1])) {
        return;
      }

      // console.log("element[1]: ", element[1])
      if (!element["stage_id"]) {
      } else {
        if (element["date_conversion"]) {
          tmp_opportunity_new.push(element);
        } else {
          if (element["create_date"]) {
            tmp_opportunity_new.push(element);
          }
        }
        if (element["stage_id"][1] == "Closing" || element["stage_id"][1] == "Gewonnen") {
          tmp_opportunity_won.push(element);
        }
        if (element["date_closed"]) {
          tmp_opportunity_lost.push(element);
        }
      }
    });

    opportunities_filtered_new = tmp_opportunity_new;
    opportunities_filtered_won = tmp_opportunity_won;
    opportunities_filtered_lost = tmp_opportunity_lost;

    console.log("opportunities_filtered_new: ", opportunities_filtered_new);

    crm_lead_all_filtered = tmp;
    opportunities_filtered = tmp_opportunity;
  }

  function filter_res_partner() {
    // sales_zustaendig
    let tmp = [];

    // console.log('salesman_selected: ', salesman_selected);

    // console.log("res_partner_all: ", res_partner_all)

    if (salesman_selected.length > 0 || country_selected.length > 0) {
      res_partner_all.forEach((element) => {
        if (country_selected.length > 0) {
          if (!element[1]["country_id"]) {
            return;
          }
          if (element[1]["country_id"][1] != country_selected) {
            return;
          }
        }

        if (element[1]["user_id"]) {
          // console.log("element[1]['user_id']: ", element[1]['user_id'])

          var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
            true,
            element[1]["user_id"][1],
            salesman_selected,
            x_team_country_dashboard,
            element[1]["country_id"][1],
            selected_team
          );

          // if(element[1]['id'] == 62967){
          //   console.log("element[1]: ", element[1])
          //   console.log("does_entry_belong_to_the_team: ", does_entry_belong_to_the_team)

          // }

          //new:
          if (does_entry_belong_to_the_team) {
            // console.log("element[1]['user_id']: ", element[1]['user_id'])
            // if (element[1]['user_id'][1] == 'Chris Howarth') {
            //   console.log('Country: ', element[1]['country_id'][1]);
            // }
            tmp.push(element[1]);
          }

          //old:
          // if (salesman_selected.includes(element[1]['user_id'][1])) {

          // }
        }
      });
      res_partner_filtered = tmp;
    }
    // console.log('res_partner_filtered: ', res_partner_filtered);
  }

  /**
   * Filter the customer with customer status active only --> customer_state = "kunde"
   * to show in the customers map.
   * Customer_state option: ["kein_kunde", "potentieller_kunde", "kunde", "ehemaliger_kunde", false, "blockierter_kunde"]
   */
  function filter_res_partner_active_customer(data) {
    let active_customer_only = [];
    data.forEach((element) => {
      if (element["customer_state"] == "kunde") {
        active_customer_only.push(element);
      }
    });
    return active_customer_only;
  }

  function calc_sankey_values_stages() {
    let lost_approach = 0;
    let lost_analysis = 0;
    let lost_offers = 0;
    let lost_closing = 0;

    console.log("lost_opportunities_filtered: ", lost_opportunities_filtered);

    //count lost:
    lost_opportunities_filtered.forEach((element) => {
      if (element["x_stage"] == "Approach") {
        lost_approach += 1;
      } else if (element["x_stage"] == "Analysis") {
        lost_analysis += 1;
      } else if (element["x_stage"] == "Offer") {
        lost_offers += 1;
      } else if (element["x_stage"] == "Closing") {
        lost_closing += 1;
      } else {
        // console.log("element['x_stage']: ", element['x_stage']);
      }
    });

    let in_approach = 0;
    let in_analysis = 0;
    let in_offers = 0;
    let in_closing = 0;
    let in_gewonnen = 0;

    opportunities_filtered.forEach((element) => {
      if (element["stage_id"][1] == "Approach") {
        in_approach += 1;
      } else if (element["stage_id"][1] == "Analysis") {
        in_analysis += 1;
      } else if (element["stage_id"][1] == "Offer") {
        in_offers += 1;
      } else if (element["stage_id"][1] == "Closing") {
        in_closing += 1;
      } else if (element["stage_id"][1] == "Gewonnen") {
        in_gewonnen += 1;
      } else {
      }
    });

    var lost_approach_color = "#e9e7e5";
    var lost_analysis_color = "#e9e7e5";
    var lost_offers_color = "#e9e7e5";
    var lost_closing_color = "#e9e7e5";

    if (first_sankey) {
      first_lost_approach = lost_approach / (in_approach + in_analysis + in_offers + in_closing + in_gewonnen);
      first_lost_analysis = lost_analysis / (in_analysis + in_offers + in_closing + in_gewonnen);
      first_lost_offers = lost_offers / (in_offers + in_closing + in_gewonnen);
      first_lost_closing = lost_closing / (in_closing + in_gewonnen);

      lost_approach_color = "#25ff37";
      lost_analysis_color = "#25ff37";
      lost_offers_color = "#25ff37";
      lost_closing_color = "#25ff37";

      first_sankey = false;
    } else {
      var this_lost_approach = lost_approach / (in_approach + in_analysis + in_offers + in_closing + in_gewonnen);
      var this_lost_analysis = lost_analysis / (in_analysis + in_offers + in_closing + in_gewonnen);
      var this_lost_offers = lost_offers / (in_offers + in_closing + in_gewonnen);
      var this_lost_closing = lost_closing / (in_closing + in_gewonnen);

      if (this_lost_approach > first_lost_approach) {
        lost_approach_color = "#8d1111";
      } else {
        lost_approach_color = "#25ff37";
      }

      if (this_lost_analysis > first_lost_analysis) {
        lost_analysis_color = "#8d1111";
      } else {
        lost_analysis_color = "#25ff37";
      }

      if (this_lost_offers > first_lost_offers) {
        lost_offers_color = "#8d1111";
      } else {
        lost_offers_color = "#25ff37";
      }

      if (this_lost_closing > first_lost_closing) {
        lost_closing_color = "#8d1111";
      } else {
        lost_closing_color = "#25ff37";
      }
    }

    // console.log('in_approach: ', in_approach);
    // console.log('in_analysis: ', in_analysis);
    // console.log('in_offers: ', in_offers);
    // console.log('in_closing: ', in_closing);
    // console.log('in_gewonnen: ', in_gewonnen);

    opportunities_lost_sankey_data = {
      nodes: [
        // { id: 'A1', extra:'blah', color: '#25EE37' },
        { id: "Converted", extra: "Converted", color: "#FFFFFF" },
        { id: "Approach", extra: "Approach", color: "#de2a29" },
        { id: "Analysis", extra: "Analysis", color: "#ffb339" },
        { id: "Offer", extra: "Offer", color: "#4e68a1" },
        { id: "Closing", extra: "Closing", color: "#27def9" },
        { id: "Gewonnen", extra: "Gewonnen", color: "#9cc926" },
        { id: "Lost Approach", extra: "Lost" },
        { id: "Lost Analysis", extra: "Lost" },
        { id: "Lost Offer", extra: "Lost" },
        { id: "Lost Closing", extra: "Lost" },
      ],
      links: [
        {
          source: "Converted",
          target: "Approach",
          value:
            in_approach + in_analysis + in_offers + in_closing + in_gewonnen + lost_approach + lost_closing + lost_offers + lost_analysis,
          show_link_text: true,
        },
        {
          source: "Approach",
          target: "Analysis",
          value: in_analysis + in_offers + in_closing + in_gewonnen + lost_closing + lost_offers + lost_analysis,
          show_link_text: true,
        },
        // { source: 'Approach', target: 'Analysis', value: 0, show_link_text: true, },
        {
          source: "Analysis",
          target: "Offer",
          value: in_offers + in_closing + in_gewonnen + lost_closing + lost_offers,
          show_link_text: true,
        },
        { source: "Offer", target: "Closing", value: in_closing + in_gewonnen + lost_closing, show_link_text: true },
        { source: "Closing", target: "Gewonnen", value: in_gewonnen, show_link_text: true },

        { source: "Approach", target: "Lost Approach", value: lost_approach, color: lost_approach_color, show_link_text: true },
        { source: "Analysis", target: "Lost Analysis", value: lost_analysis, color: lost_analysis_color, show_link_text: true },
        { source: "Offer", target: "Lost Offer", value: lost_offers, color: lost_offers_color, show_link_text: true },
        { source: "Closing", target: "Lost Closing", value: lost_closing, color: lost_closing_color, show_link_text: true },
      ],
    };
  }

  function stacked_to_excel_dict(chart, title) {
    var obj = {
      months: chart["labels"],
      names: [],
      values: {},
      title: title,
    };

    chart["datasets"].forEach((element) => {
      obj["names"].push(element["label"]);
      obj["values"][element["label"]] = [];

      element["data"].forEach((value) => {
        var v = value;
        if (v === undefined) {
          v = 0;
        }

        obj["values"][element["label"]].push(v);
      });
    });

    return obj;
  }

  function is_active_sales(item) {
    if (power_chart_data_salesman_index.includes(item)) {
      return true;
    } else {
      return false;
    }
  }

  function export_weekly_excel(e, year, week_from, week_to, month_from, month_to, month_checked, all = false) {
    var sales_persons_for_excel = e.filter((item) => item !== "Stefan Bürscher" && is_active_sales(item));

    var obj = {
      sales_persons: sales_persons_for_excel,
      title: "weekly_report",
      year: year,
      week_from: week_from,
      week_to: week_to,
      all: all,
      teams: salesteams_all,
      month_checked: month_checked,
    };

    let timeframe_from = year;
    let timeframe_to = year;
    let weekly_or_monthly = "";

    if (month_checked) {
      obj["week_from"] = month_from;
      obj["week_to"] = month_to;
      timeframe_from = timeframe_from + "_" + month_from.value.toString();
      timeframe_to = timeframe_to + "_" + month_to.value.toString();
      weekly_or_monthly = "Monthly";
    } else {
      timeframe_from = timeframe_from + "_" + week_from.value.toString();
      timeframe_to = timeframe_to + "_" + week_to.value.toString();
      weekly_or_monthly = "Weekly";
    }

    // return;

    createByUrlWithThen(get_ip_address_prefix() + "/rest/api_create_big_excel/", obj).then((response) =>
      response.blob().then(async function (blob) {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        let filename = "Sales " + weekly_or_monthly + " Report " + timeframe_from + "-" + timeframe_to + ".xlsx";
        a.href = url;
        a.download = filename;
        a.click();
      })
    );
  }

  function export_excel() {
    var obj = {
      sold_boli_per_month_linechart_data: stacked_to_excel_dict(sold_boli_per_month_linechart_data, "Sold BOLUSES per Month"),
      new_customer_herdsize_linechart_data: stacked_to_excel_dict(new_customer_herdsize_linechart_data, "New Customers per Herdsize"),
      sold_boli_per_month_angebote_linechart_data: stacked_to_excel_dict(sold_boli_per_month_angebote_linechart_data, "Offers Won"),

      converted_line_chart: stacked_to_excel_dict(converted_line_chart, "Conversions"),
      table_alltime_open_opportunities: stacked_to_excel_dict(table_alltime_open_opportunities, "Open Opportunities"),
      activity_chart: stacked_to_excel_dict(activity_chart, "Completed Activities"),
      activity_chart_won_opportunities: stacked_to_excel_dict(activity_chart_won_opportunities, "Completed Activities (Won Opportunities)"),
      activity_chart_lost_opportunities: stacked_to_excel_dict(
        activity_chart_lost_opportunities,
        "Completed Activities (Lost Opportunities)"
      ),
      subscriptions_cancelled_chart: stacked_to_excel_dict(subscriptions_cancelled_chart, "Cancelled Subscriptions"),
    };

    if (power_chart_table) {
      obj["ranking"] = power_chart_to_excel(power_chart_table, power_chart_column_names, "Ranking");
    }

    createByUrlWithThen(get_ip_address_prefix() + "/rest/api_create_excel/", obj).then((response) =>
      response.blob().then(async function (blob) {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");

        a.href = url;
        a.download = "Sales Dashboard Export.xlsx";
        a.click();
      })
    );
  }

  function filter_sales(data) {
    let filtered_list = [];
    let filtered_list_angebot = [];

    if (selected_team == "smX HQ") {
      salesman_selected.push("Others");
    }

    data.forEach((element) => {
      let obj = element[1];

      if (obj["id"] == 91175) {
        console.log("########91175: ", obj);
      }

      if (country_selected.length > 0) {
        if (!element[1]["country"]) {
          return;
        }
        if (element[1]["country"] != country_selected) {
          return;
        }
      }

      // console.log("element[1]['salesman_id'][1]: ", element[1]['salesman_id'][1])
      // if(element[1]['salesman_id'][1] == 'Clint Brereton'){
      //   console.log("HEY: ", obj)
      // }

      var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
        false,
        element[1]["salesman_id"][1],
        salesman_selected,
        x_team_country_dashboard,
        element[1]["country"],
        selected_team
      );

      // if(obj['order__date'] && obj['order__date'].substring(0, 7) == "2023-05" && element[1]['salesman_id'][1] == "Aisling Downey" && (obj['state'] == 'done' || obj['state'] == 'sale')){
      //     console.log("obj: ", obj)
      //     console.log("does_entry_belong_to_the_team: ", does_entry_belong_to_the_team)
      //   }

      if (obj["order__date"] && does_entry_belong_to_the_team && (obj["state"] == "done" || obj["state"] == "sale")) {
        filtered_list.push(element[1]);
      } else {
      }

      if (obj["order__date"] && does_entry_belong_to_the_team && (obj["state"] == "done" || obj["state"] == "sale")) {
        filtered_list_angebot.push(element[1]);
      } else {
        // console.log("obj1: ", obj)
      }
    });

    sale_order_filtered = filtered_list;
    sale_order_filtered_angebot = filtered_list_angebot;

    let sales_price_null_tmp = [];

    let count_state = 0;
    let count_date = 0;
    let count_salesman = 0;
    let count_product_type = 0;

    let count_bolus_cat = 0;
    let count_final = 0;

    sales_price_null_original.forEach((element) => {
      let obj = element[1];

      if (country_selected.length > 0) {
        if (!element[1]["country"]) {
          return;
        }
        if (element[1]["country"] != country_selected) {
          return;
        }
      }

      var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
        false,
        element[1]["salesman_id"][1],
        salesman_selected,
        x_team_country_dashboard,
        element[1]["country"],
        selected_team
      );

      if (
        obj["x_studio_product_category"] != "Sales Product / Classic Bolus" &&
        obj["x_studio_product_category"] != "Sales Product / pH Bolus"
      ) {
        count_product_type = count_product_type + 1;
        return;
      } else {
        count_bolus_cat = count_bolus_cat + 1;
      }

      if (!obj["x_studio_order_date_mw"]) {
        count_date = count_date + 1;
        return;
      }

      if (!does_entry_belong_to_the_team) {
        count_salesman = count_salesman + 1;
        return;
      }
      if (!(obj["state"] == "done" || obj["state"] == "sale")) {
        count_state = count_state + 1;
        return;
      } else {
        count_final = count_final + 1;
      }

      sales_price_null_tmp.push(element[1]);
    });

    sales_price_null = sales_price_null_tmp;
  }

  function calc_sold_boli_per_month(data, months, only_invoiced = false, use_ph_bolus = false) {
    let sum_dict = {};
    let new_dict_sum = {};
    let recurring_dict_sum = {};
    let won_angebote_dict = {};

    let sum_dict_list = {};

    let recurrent_dict_list = {};

    let status_liste_tmp = [];

    let sales_list_for_debug = {};

    let check_sold_bolus = {};

    let current_month = new Date().getMonth();
    let current_year = new Date().getFullYear();

    months.forEach((year_month) => {
      if (!(parseInt(year_month.substring(0, 4)) >= current_year && parseInt(year_month.slice(-2)) > current_month + 1)) {
        sum_dict[year_month] = 0;
        sum_dict_list[year_month] = {};
        recurrent_dict_list[year_month] = {};
        recurring_dict_sum[year_month] = 0;
        new_dict_sum[year_month] = 0;
        won_angebote_dict[year_month] = 0;
      }
    });

    data.forEach((element) => {
      let year_month = element["order__date"].substring(0, 7);

      if (only_invoiced) {
        if (!element["invoice_status"]) {
          return;
        }

        if (element["invoice_status"] != "invoiced") {
          return;
        }
      }

      if (!(year_month in sales_list_for_debug)) {
        sales_list_for_debug[year_month] = [];
      }

      if (!(element["product__amount"] > 0)) {
        return;
      }

      if (!(element["price_total"] > 0)) {
        return;
      }

      // filtered out the sales if its product id not includes pH and Classic bolus
      if (use_ph_bolus) {
        if (element["product_type"] != "Sales Product / pH Bolus") {
          return;
        }
      }

      if (!use_ph_bolus) {
        if (!element["product_id"][1].includes("Classic Bolus")) {
          return;
        }
      }

      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      if (element["order_type"] != "new" && element["order_type"] != false && element["order_type"] != "Reorder") {
        // console.log("element that is not new order type and price > 0: ", element)
        return;
      }

      won_angebote_dict[year_month] = won_angebote_dict[year_month] + 1;

      if (!status_liste_tmp.includes(element["state"])) {
        status_liste_tmp.push(element["state"]);
      }

      // console.log("element: ", element)
      if (check_sold_bolus[year_month]) {
        if (check_sold_bolus[year_month][element["salesman__name"]]) {
          check_sold_bolus[year_month][element["salesman__name"]].push(element);
        } else {
          check_sold_bolus[year_month][element["salesman__name"]] = [];
          check_sold_bolus[year_month][element["salesman__name"]].push(element);
        }
      } else {
        check_sold_bolus[year_month] = {};
        check_sold_bolus[year_month][element["salesman__name"]] = [];
        check_sold_bolus[year_month][element["salesman__name"]].push(element);
      }
      // }

      if (year_month in sum_dict) {
        sum_dict[year_month] = sum_dict[year_month] + element["product__amount"];
        sum_dict_list[year_month][element["order_id"][1] + " qty: " + element["product__amount"]] = element;
      } else {
        sum_dict[year_month] = element["product__amount"];
        sum_dict_list[year_month][element["order_id"][1] + " qty: " + element["product__amount"]] = element;
      }

      if (!element["order__recurrency"]) {
        sales_list_for_debug[year_month].push(element);
        if (year_month in new_dict_sum) {
          new_dict_sum[year_month] = new_dict_sum[year_month] + element["product__amount"];
        } else {
          new_dict_sum[year_month] = element["product__amount"];
        }
      } else {
        recurrent_dict_list[year_month][element["order_id"][1] + " qty: " + element["product__amount"]] = element;
        if (year_month in recurring_dict_sum) {
          recurring_dict_sum[year_month] = recurring_dict_sum[year_month] + element["product__amount"];
        } else {
          recurring_dict_sum[year_month] = element["product__amount"];
        }
      }
    });

    console.log("check sold bolus list", check_sold_bolus);

    let dict = {
      sum_dict: sum_dict,
      new_dict_sum: new_dict_sum,
      recurring_dict_sum: recurring_dict_sum,
      won_angebote_dict: won_angebote_dict,
    };

    console.log("check sold bolus list dict", dict);

    return { dict: dict, dict_lists: sum_dict_list, recurrent_dict_list: recurrent_dict_list };
  }

  function calc_year_buttons() {
    current_year_button = new Date().getFullYear().toString();

    let tmp = current_year_button;

    while (tmp >= 2020) {
      year_buttons.push(tmp.toString());
      tmp = tmp - 1;
    }
  }

  async function do_all_calculations() {
    console.log("do all calculations...");

    filter_all();

    months = calc_months_from_selected_year(year_filter);

    let tmp;

    if (salesman_selected.length == 0) {
      return;
    }

    calc_sankey_values_stages();

    tmp = calculate_open_opportunities_per_month(opportunities_filtered, lost_opportunities_filtered, year_filter);

    var keys_opports = tmp["keys"];
    var val_open_opports = tmp["values"];

    table_alltime_open_opportunities = false;
    op_chart = false;
    sold_boli_per_month_angebote_linechart_data = false;
    table_alltime_open_opportunities = create_multi_line_chart_dataset(keys_opports, [val_open_opports], ["open"]);

    tmp = calculate_cancelled_subscriptions(subscription_all_filtered, year_filter);

    subscriptions_cancelled_chart = create_multi_line_chart_dataset(tmp["keys"], [tmp["values"]], ["cancelled"]);

    tmp = count_opportunities_without_activity(opportunities_filtered, year_filter);
    opportunities_without_action_count = tmp["count"];
    opportunities_without_action_list = tmp["without_activity_list"];

    tmp = count_opportunities_with_overdue_activity(opportunities_filtered, year_filter);
    opportunities_with_overdue_activity_count = tmp["count"];
    opportunities_with_overdue_activity_list = tmp["with_overdue_activity_list"];

    tmp = count_opportunities_wit_abschluss_past(opportunities_filtered);

    opportunities_wit_abschluss_past_count = tmp["count"];
    opportunities_wit_abschluss_past_list = tmp["list"];

    opportunities_wit_abschluss_past_list_table_data = create_table_data_opportunities(opportunities_wit_abschluss_past_list);

    opportunities_without_action_list_table = create_table_data_opportunities(opportunities_without_action_list);

    opportunities_with_overdue_activity_list_table = create_table_data_opportunities(opportunities_with_overdue_activity_list);

    tmp = create_leads_tabelle(crm_lead_all_filtered);

    let leads_offen_table_tmp = {};
    leads_offen_table_tmp["columns"] = tmp["columns"];
    leads_offen_table_tmp["values"] = tmp["values"];

    leads_offen_table = leads_offen_table_tmp;
    leads_offen_table_cpy_values = leads_offen_table["values"];

    tmp = count_leas_older_three_days(crm_lead_all_filtered);
    leads_older_three_days = tmp["count"];

    let leads_older_three_days_table_tmp = {};
    leads_older_three_days_table_tmp["values"] = tmp["values"];
    leads_older_three_days_table_tmp["columns"] = tmp["columns"];

    leads_older_three_days_table = leads_older_three_days_table_tmp;
    leads_older_three_days_table_before_last_filter = [];

    leads_older_three_days_table["values"].forEach((element) => {
      leads_older_three_days_table_before_last_filter.push(element);
    });

    list_of_sources = [];
    list_of_sources = create_list_of_sources(tmp["values"]);

    list_of_sources.forEach((element) => {
      list_of_sources_dict[element] = true;
      var items = document.getElementsByClassName(element);
      let numItems = items.length;
      for (let i = 0; i < numItems; i++) {
        items[i].checked = true;
      }
    });

    let ncpmld = calc_new_customers_per_month_linechart_data(cust_goals_filtered, months, res_partner_filtered);
    new_customers_per_month_linechart_data = ncpmld["chart"];

    var new_cust_dict = ncpmld["values"];
    var new_cust_target_dict = ncpmld["targets"];

    let ccv = calc_cust_gauge_values(new_cust_dict, new_cust_target_dict, year_filter);
    set_customer_gauge(ccv["current_cust"], ccv["current_month_goal"], ccv["you_should_be_here"], ccv["enough"]);

    sold_enough_clients = ccv["enough"];

    current_new_clients = ccv["current_cust"];
    yearly_goal_new_clients = ccv["current_month_goal"];

    let activity_dict;
    activity_dict = calc_activiti_cat_dict_generic(mail_activity_all, mail_activity_all_filtered, "date", true, "won");

    activity_chart_won_opportunities = false;
    activity_chart_lost_opportunities = false;

    activity_chart_won_opportunities = create_multi_line_chart_dataset(
      activity_dict["keys"],
      activity_dict["values"],
      activity_dict["type_names"]
    );

    activity_dict = calc_activiti_cat_dict_generic(mail_activity_all, mail_activity_all_filtered, "date", true, "lost");
    activity_chart_lost_opportunities = create_multi_line_chart_dataset(
      activity_dict["keys"],
      activity_dict["values"],
      activity_dict["type_names"]
    );

    activity_dict = calc_activiti_cat_dict_generic(mail_activity_all, mail_activity_all_filtered, "date", true);
    activity_chart = false;
    activity_chart = create_multi_line_chart_dataset(activity_dict["keys"], activity_dict["values"], activity_dict["type_names"]);

    console.log("opportunities_filtered_won: ", opportunities_filtered_won);

    let tmp_op_chart = calc_opportunities_chart(
      opportunities_filtered_new,
      opportunities_filtered_won,
      lost_opportunities_filtered,
      year_filter
    );

    op_chart = create_multi_line_chart_dataset(
      tmp_op_chart["keys"],
      tmp_op_chart["values"],
      ["new", "won", "lost"],
      ["#faf750", "#1dc447", "#cf3a3a"]
    );

    tmp = calc_converted(opportunities_filtered, year_filter);

    converted_line_chart = create_multi_line_chart_dataset(tmp["keys"], [tmp["values"]], ["converted"]);

    herd_coverage = calculate_herd_coverage(res_partner_filtered);

    var activeanimals = herd_coverage["datasets"][0];
    var herdsize_without_active = herd_coverage["datasets"][1];
    var herdisze = activeanimals + herdsize_without_active;

    var percentage_coverage = (activeanimals / herdisze) * 100;

    if (herdisze == 0) {
      percentage_coverage = 0;
    }

    herd_coverage_percentage = percentage_coverage.toFixed(2);

    set_gauge("gauge_canvas_id", herd_coverage_percentage, opts_herdcoverage);
    set_gauge("gauge_canvas_id_map", herd_coverage_percentage, opts_herdcoverage);

    if (percentage_coverage <= 100 && percentage_coverage >= 80) {
      herd_coverage_color = "#20d629";
    }
    if (percentage_coverage < 80 && percentage_coverage >= 75) {
      herd_coverage_color = "#c7e833";
    }
    if (percentage_coverage < 75 && percentage_coverage >= 50) {
      herd_coverage_color = "#d69320";
    }
    if (percentage_coverage < 50 && percentage_coverage >= 0) {
      herd_coverage_color = "#bd321c";
    }

    let sold_boli_per_month_list_and_dict = calc_sold_boli_per_month(sale_order_filtered, months.reverse());

    let sold_ph_boli_per_month_list_and_dict = calc_sold_boli_per_month(sale_order_filtered, months.reverse(), false, true);

    let sold_boli_per_month_list_and_dict_invoiced = calc_sold_boli_per_month(sale_order_filtered, months.reverse(), true)["dict"];

    let sold_boli_per_month = sold_boli_per_month_list_and_dict["dict"];
    let sold_ph_boli_per_month = sold_ph_boli_per_month_list_and_dict["dict"];

    let sold_boli_per_month_lists = dict_to_list(sold_boli_per_month["sum_dict"]);
    let sold_boli_per_month_lists_recurring = dict_to_list(sold_boli_per_month["recurring_dict_sum"]);

    let sold_ph_boli_per_month_lists = dict_to_list(sold_ph_boli_per_month["sum_dict"]);

    let all_sold_boli_line_data_lists = [];

    var current_year;
    if (year_filter == "ALL") {
      current_year = new Date().getFullYear().toString();
    } else {
      current_year = year_filter;
    }

    var x = 0;
    sold_boli_sum = 0;
    while (x < sold_boli_per_month_lists["keys"].length) {
      if (sold_boli_per_month_lists["keys"][x].substring(0, 4) == current_year) {
        sold_boli_sum = sold_boli_sum + sold_boli_per_month_lists["values"][x];
      }
      x = x + 1;
    }

    all_sold_boli_line_data_lists.push(sold_boli_per_month_lists["values"].reverse());
    all_sold_boli_line_data_lists.push(sold_boli_per_month_lists_recurring["values"].reverse());

    tmp = create_goals_list_for_sold_list(filter_goals_filtered, sold_boli_per_month_lists["keys"], year_filter);

    let goals_list = tmp["value"];
    let goals_index = tmp["keys"];

    x = 0;
    goals_sum = 0;

    while (x < goals_index.length) {
      if (goals_index[x].substring(0, 4) == current_year) {
        if (goals_list[x]) {
          goals_sum = goals_sum + goals_list[x];
        }
      }
      x = x + 1;
    }

    all_sold_boli_line_data_lists.push(goals_list);

    let indexe_merged = merge_index(sold_boli_per_month_lists["keys"].reverse(), goals_index.sort());

    let prediction_lists = create_prediction(indexe_merged, opportunities_filtered);

    if (year_filter == "ALL" || year_filter == new Date().getFullYear()) {
      all_sold_boli_line_data_lists.push(prediction_lists["unweighted"]);
      all_sold_boli_line_data_lists.push(prediction_lists["weighted"]);
    }

    sold_boli_per_month_linechart_data = create_multi_line_chart_dataset(
      indexe_merged,
      all_sold_boli_line_data_lists,
      ["all", "recurring", "goals", "unweighted prediction", "weighted prediction", ""],
      ["#f2cd17", "#734de1", "#a8e962", "#a0b984", "#aa5500"]
    );

    sold_ph_boli_per_month_linechart_data = create_multi_line_chart_dataset(
      sold_ph_boli_per_month_lists["keys"],
      [sold_ph_boli_per_month_lists["values"]],
      ["all", "recurring", "goals"],
      ["#f2cd17", "#734de1", "#a8e962", "#a0b984", "#aa5500"]
    );

    let all_sold_boli_line_data_lists_invoiced = [];
    all_sold_boli_line_data_lists_invoiced.push(sold_boli_per_month_list_and_dict_invoiced["new_dict_sum"]);
    all_sold_boli_line_data_lists_invoiced.push(sold_boli_per_month_list_and_dict_invoiced["recurring_dict_sum"]);
    all_sold_boli_line_data_lists_invoiced.push(goals_list);

    sold_boli_per_month_invoiced_linechart_data = create_multi_line_chart_dataset(
      indexe_merged,
      all_sold_boli_line_data_lists_invoiced,
      ["new", "recurring", "goals"],
      ["#f2cd17", "#734de1", "#a8e962", "#a0b984", "#aa5500"]
    );

    calc_boli_order_type_per_month(indexe_merged, sale_order_filtered, "Warranty / Goodwill", "x_studio_order_type");

    let boli_sales_price_null = calc_boli_sales_price_null_per_month(indexe_merged, sales_price_null);

    let boli_sales_warranty_goodwill_old_field = calc_boli_sales_warranty_goodwill_old_field(indexe_merged, sales_price_null);

    let boli_price_warranty = calc_boli_order_type_per_month(indexe_merged, sales_price_null, "Warranty / Goodwill", "order_type");

    let boli_price_referral = calc_boli_order_type_per_month(indexe_merged, sales_price_null, "referral", "order_type");

    let boli_price_goodwill = calc_boli_order_type_per_month(indexe_merged, sales_price_null, "goodwill", "order_type");

    boli_price_null_per_month_linechart_data = create_multi_line_chart_dataset(
      indexe_merged,
      [
        dict_to_list(boli_sales_price_null)["values"],
        dict_to_list(boli_price_warranty)["values"],
        dict_to_list(boli_price_referral)["values"],
        dict_to_list(boli_price_goodwill)["values"],
        dict_to_list(boli_sales_warranty_goodwill_old_field)["values"],
      ],
      ["price is 0", "Warranty", "Referral", "Goodwill", "Warranty / Goodwill"],
      ["#f2cd17", "#734de1", "#a8e962", "#d99011", "#30B32D"]
    );

    let boli_new_reorder = calc_boli_reorder_and_new(indexe_merged, sale_order_filtered);

    boli_new_reorder_linechart_data = create_multi_line_chart_dataset(
      indexe_merged,
      [boli_new_reorder["new"], boli_new_reorder["reorder"]],
      ["New", "Reorder"],
      ["#f2cd17", "#734de1"]
    );

    new Date().getFullYear().toString() + "-" + new Date().getMonth().toString();

    var now = new Date();
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = now - start;
    var oneDay = 1000 * 60 * 60 * 24;
    Math.floor(diff / oneDay);

    let current_month_boli_sold = sold_boli_sum;
    let current_moth_boli_goal = goals_sum;
    let you_should_be_here = 0;

    x = 0;

    var current_month_int = new Date().getMonth() + 1;
    var current_month_string = current_month_int.toString();
    var current_day_in_month = new Date().getDate();
    var days_in_month = new Date(current_year, current_month_int, 0).getDate();

    if (current_month_string.length == 1) {
      current_month_string = "0" + current_month_string;
    }

    var goal_until_now = 0;

    while (x < goals_index.length) {
      if (goals_index[x].substring(0, 4) == current_year) {
        var month = parseInt(goals_index[x].substring(5, 7));

        if (goals_list[x]) {
          if (month == current_month_int) {
            goal_until_now = goal_until_now + goals_list[x] * (current_day_in_month / days_in_month);
          } else {
            if (month < current_month_int) {
              goal_until_now = goal_until_now + goals_list[x];
            }
          }
        }
      }
      x = x + 1;
    }

    if (current_moth_boli_goal) {
      // you_should_be_here = (current_moth_boli_goal / 365) * day_in_year;
      you_should_be_here = goal_until_now;
    }

    if (current_month_boli_sold > you_should_be_here) {
      sold_enough = true;
    } else {
      sold_enough = false;
    }

    if (new Date().getFullYear().toString() != current_year) {
      you_should_be_here = current_moth_boli_goal;
    }

    global_current_moth_boli_goal = current_moth_boli_goal;

    set_gauge_boli_sold_to_target(current_month_boli_sold, current_moth_boli_goal, you_should_be_here);

    // current MOnth chart data:
    current_month_bar_chart = create_multi_line_chart_dataset(
      ["Sold", "Goal", "current Target to reach Goal"],
      [
        [current_month_boli_sold, 0, 0],
        [0, current_moth_boli_goal, 0],
        [0, 0, you_should_be_here],
      ],
      ["Boli"]
    );

    // angebot, angebot gesendet, verkaufsauftrag:
    // sale_order_filtered_angebot
    let sold_boli_angebote_per_month = calc_sold_boli_per_month(sale_order_filtered_angebot, months.reverse());

    console.log("sold_boli_angebote_per_month", sold_boli_angebote_per_month);

    let sold_boli_per_month_angebote_lists = dict_to_list(sold_boli_angebote_per_month["dict"]["won_angebote_dict"]);
    // console.log("sold_boli_per_month_angebote_lists: ", sold_boli_per_month_angebote_lists)
    sold_boli_per_month_angebote_linechart_data = create_multi_line_chart_dataset(
      sold_boli_per_month_angebote_lists["keys"].reverse(),
      [sold_boli_per_month_angebote_lists["values"].reverse()],
      [""]
    );

    // neue Kunden per Monat:

    new_customer_herdsize_linechart_data = false;

    if (res_partner_filtered.length > 0) {
      // let res_partner_filtered_for_herdsize = filter_year(res_partner_filtered, 'first_order_date', year_filter);
      let res_partner_filtered_for_herdsize = filter_for_new_client(
        res_partner_all,
        "first_order_date",
        year_filter,
        country_selected,
        selected_team,
        x_team_country_dashboard,
        salesman_selected
      );

      let new_customer_herd_size_dict_and_lists = calc_new_customer_herd_size(res_partner_filtered_for_herdsize);

      console.log("new_customer_herd_size_dict_and_lists: ", new_customer_herd_size_dict_and_lists);

      let new_customer_herd_size = new_customer_herd_size_dict_and_lists["dict"];

      if (Object.keys(new_customer_herd_size).length) {
        const keys_of_herdsize_dicts = Object.keys(new_customer_herd_size[Object.keys(new_customer_herd_size)[0]]);
        let dict_of_herdsize_lists = {};

        const month_keys = Object.keys(new_customer_herd_size);

        keys_of_herdsize_dicts.forEach((element) => {
          dict_of_herdsize_lists[element] = [];
        });

        month_keys.sort().reverse();

        month_keys.forEach((month) => {
          keys_of_herdsize_dicts.forEach((key) => {
            let new_customers_one_month_and_herdsize = new_customer_herd_size[month][key];

            dict_of_herdsize_lists[key].push(new_customers_one_month_and_herdsize);
          });
        });

        let data_lists = [];

        for (var key in dict_of_herdsize_lists) {
          data_lists.push(dict_of_herdsize_lists[key].reverse());
        }

        new_customer_herdsize_linechart_data = create_multi_line_chart_dataset(month_keys, data_lists, keys_of_herdsize_dicts);

        // console.log('new_customer_herdsize_linechart_data: ', new_customer_herdsize_linechart_data);

        month_keys_chart = month_keys;

        let new_customer_herdsize_bar_chart_tmp = [];
        let tmp_bar_datalist = [];

        for (var i = 0; i < month_keys.length; i++) {
          let bar_month_index = i;
          tmp_bar_datalist = [];
          for (const x of data_lists) {
            tmp_bar_datalist.push(x[bar_month_index]);
          }
          new_customer_herdsize_bar_chart_tmp.push(create_bar_chart_dataset(keys_of_herdsize_dicts, tmp_bar_datalist));
        }

        month_keys_chart.reverse();
        new_customer_herdsize_bar_chart_tmp.reverse();
        new_customer_herdsize_bar_chart = new_customer_herdsize_bar_chart_tmp;
      } else {
        new_customer_herdsize_bar_chart = false;
      }
    }

    var year = new Date().getFullYear();
    if (year_filter != "ALL") {
      year = year_filter;
    }
    if (power_chart_data_salesman_index && power_chart_data) {
      var tmp_pc = calculate_powerchart_over_year_ranks(power_chart_data, power_chart_data_salesman_index, year);
      over_year_ranks = tmp_pc["ranks"];
      pcline = tmp_pc["pcline"];
    }

    if (salesman_selected.length == 1) {
      if (salesman_selected[0] != "Others") {
        tmp = create_power_chart_table(power_chart_data_filtered, pcline[salesman_selected[0]], year_filter);
        power_chart_table = tmp["chart"];
        boli_sold_rank = over_year_ranks[salesman_selected[0]]["classic_boli_sold"];
        first_visit_rank = over_year_ranks[salesman_selected[0]]["First Visit Potential Customer"];
        calls_rank = over_year_ranks[salesman_selected[0]]["Call"];
      }
    }
  }

  function calc_new_customer_herd_size(data) {
    let dict = {};
    let dict_lists = {};

    data.forEach((element) => {
      var date_to_use = element["first_order_date"];

      if (!(element["company_type"] == "company")) {
        return;
      }

      if (element["x_studio_kunde_seit"]) {
        var date_obj_element_kunde_seit = new Date(element["x_studio_kunde_seit"]);
        if (element["first_order_date"]) {
          var date_obj_first_order_date = new Date(element["first_order_date"]);
          if (date_obj_element_kunde_seit < date_obj_first_order_date) {
            date_to_use = element["x_studio_kunde_seit"];
          }
        } else {
          date_to_use = element["x_studio_kunde_seit"];
        }
      }

      if (element["id"] == 67322) {
        console.log("1Gilbert: ", element);
      }

      if (date_to_use) {
        dict[date_to_use.substring(0, 7)] = {
          "0-30": 0,
          "30-60": 0,
          "60-100": 0,
          "100-150": 0,
          "150-300": 0,
          "300-500": 0,
          "500-800": 0,
          "800-1500": 0,
          ">1500": 0,
        };

        dict_lists[date_to_use.substring(0, 7)] = {
          "0-30": [],
          "30-60": [],
          "60-100": [],
          "100-150": [],
          "150-300": [],
          "300-500": [],
          "500-800": [],
          "800-1500": [],
          ">1500": [],
        };
      }
    });

    data.forEach((element) => {
      var date_to_use = element["first_order_date"];

      if (!(element["company_type"] == "company")) {
        return;
      }

      if (element["x_studio_kunde_seit"]) {
        var date_obj_element_kunde_seit = new Date(element["x_studio_kunde_seit"]);
        if (element["first_order_date"]) {
          var date_obj_first_order_date = new Date(element["first_order_date"]);
          if (date_obj_element_kunde_seit < date_obj_first_order_date) {
            date_to_use = element["x_studio_kunde_seit"];
          }
        } else {
          date_to_use = element["x_studio_kunde_seit"];
        }
      }

      if (date_to_use) {
        let herdsize = element["x_studio_herdengre_1"];

        if (element["id"] == 67322) {
          console.log("2Gilbert: ", element);
          console.log("herdsize: ", herdsize);
        }

        if (herdsize >= 0 && herdsize <= 30) {
          dict[date_to_use.substring(0, 7)]["0-30"] = dict[date_to_use.substring(0, 7)]["0-30"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["0-30"].push(element);
        }
        if (herdsize >= 31 && herdsize <= 60) {
          dict[date_to_use.substring(0, 7)]["30-60"] = dict[date_to_use.substring(0, 7)]["30-60"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["30-60"].push(element);
        }
        if (herdsize >= 61 && herdsize <= 100) {
          dict[date_to_use.substring(0, 7)]["60-100"] = dict[date_to_use.substring(0, 7)]["60-100"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["60-100"].push(element);
        }
        if (herdsize >= 101 && herdsize <= 150) {
          dict[date_to_use.substring(0, 7)]["100-150"] = dict[date_to_use.substring(0, 7)]["100-150"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["100-150"].push(element);
        }
        if (herdsize >= 151 && herdsize <= 300) {
          dict[date_to_use.substring(0, 7)]["150-300"] = dict[date_to_use.substring(0, 7)]["150-300"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["150-300"].push(element);
          if (element["id"] == 67322) {
            console.log("2Gilbert: ", element);
            console.log("herdsize: ", herdsize);
            console.log("date_to_use: ", date_to_use);
            console.log("date_to_use.substring(0, 7): ", date_to_use.substring(0, 7));
          }
        }
        if (herdsize >= 301 && herdsize <= 500) {
          dict[date_to_use.substring(0, 7)]["300-500"] = dict[date_to_use.substring(0, 7)]["300-500"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["300-500"].push(element);
        }
        if (herdsize >= 501 && herdsize <= 800) {
          dict[date_to_use.substring(0, 7)]["500-800"] = dict[date_to_use.substring(0, 7)]["500-800"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["500-800"].push(element);
        }
        if (herdsize >= 801 && herdsize <= 1500) {
          dict[date_to_use.substring(0, 7)]["800-1500"] = dict[date_to_use.substring(0, 7)]["800-1500"] + 1;
          dict_lists[date_to_use.substring(0, 7)]["800-1500"].push(element);
        }
        if (herdsize >= 1501) {
          dict[date_to_use.substring(0, 7)][">1500"] = dict[date_to_use.substring(0, 7)][">1500"] + 1;
          dict_lists[date_to_use.substring(0, 7)][">1500"].push(element);
        }
      }
    });

    return { dict: dict, dict_lists: dict_lists };
  }

  function calc_fiscal_position_id_diagramm() {
    let account_move_all_data_original_filtered_currencys = divide_by(account_move_all_data_original_filtered, "fiscal_position_id", 1);

    let tmp_date;
    let tmp_count = [];
    let tmp_labels = [];

    for (const [key, value] of Object.entries(account_move_all_data_original_filtered_currencys)) {
      let tmp = specific_data_all_to_month_with_date_name(value, "date", "amount_total");
      tmp_date = get_single_column(tmp, 0);
      tmp_count.push(get_single_column(tmp, 1));
      tmp_labels.push(key);
    }
    account_moves_chart_dataset_fiscal_position_id = create_multi_line_chart_dataset(tmp_date, tmp_count, tmp_labels);
  }

  function calc_leadFinder_diagramm() {
    let account_move_all_data_original_filtered_currencys = divide_by(account_move_all_data_original_filtered, "leadFinder", 1);

    let tmp_date;
    let tmp_count = [];
    let tmp_labels = [];

    for (const [key, value] of Object.entries(account_move_all_data_original_filtered_currencys)) {
      let tmp = specific_data_all_to_month_with_date_name(value, "date", "amount_total");
      tmp_date = get_single_column(tmp, 0);
      tmp_count.push(get_single_column(tmp, 1));
      tmp_labels.push(key);
    }
    account_moves_chart_dataset_leadFinder = create_multi_line_chart_dataset(tmp_date, tmp_count, tmp_labels);
  }

  function calc_distributionsPartner_diagramm() {
    let account_move_all_data_original_filtered_currencys = divide_by(account_move_all_data_original_filtered, "distributionPartner", 1);

    let tmp_date;
    let tmp_count = [];
    let tmp_labels = [];

    for (const [key, value] of Object.entries(account_move_all_data_original_filtered_currencys)) {
      let tmp = specific_data_all_to_month_with_date_name(value, "date", "amount_total");
      tmp_date = get_single_column(tmp, 0);
      tmp_count.push(get_single_column(tmp, 1));
      tmp_labels.push(key);
    }
    account_moves_chart_dataset_distributionPartner = create_multi_line_chart_dataset(tmp_date, tmp_count, tmp_labels);
  }

  function calc_currency_diagramm() {
    let account_move_all_data_original_filtered_currencys = divide_by(account_move_all_data_original_filtered, "currency_id", 1);

    let tmp_date;
    let tmp_count = [];
    let tmp_labels = [];

    for (const [key, value] of Object.entries(account_move_all_data_original_filtered_currencys)) {
      let tmp = specific_data_all_to_month_with_date_name(value, "date", "amount_total");

      tmp_date = get_single_column(tmp, 0);
      tmp_count.push(get_single_column(tmp, 1));
      tmp_labels.push(key);
    }
    account_moves_chart_dataset = create_multi_line_chart_dataset(tmp_date, tmp_count, tmp_labels);
  }

  function calc_teams_diagramm() {
    let account_move_all_data_original_filtered_teams = divide_by(account_move_all_data_original_filtered, "team_id", 1);

    let tmp_date;
    let tmp_count = [];
    let tmp_labels = [];

    for (const [key, value] of Object.entries(account_move_all_data_original_filtered_teams)) {
      let tmp = specific_data_all_to_month_with_date_name(value, "date", "amount_total");
      tmp_date = get_single_column(tmp, 0);
      tmp_count.push(get_single_column(tmp, 1));
      tmp_labels.push(key);
    }
    account_moves_chart_dataset_teams = create_multi_line_chart_dataset(tmp_date, tmp_count, tmp_labels);
  }

  function set_gauge_boli_sold_to_target(current_month_boli_sold, current_moth_boli_goal, you_should_be_here) {
    if (!current_moth_boli_goal || !you_should_be_here) {
      disable_current_month = true;
      return;
    }

    disable_current_month = false;

    var opts_herdcoverage = {
      angle: -0.2, // The span of the gauge arc
      lineWidth: 0.4, // The line thickness
      radiusScale: 0.85, // Relative radius
      pointer: {
        length: 0.6, // // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#000000", // Fill color
      },
      renderTicks: {
        divisions: 10,
        divWidth: 0.7,
        divLength: 0.7,
        divColor: "#333333",
        subDivisions: 10,
        subLength: 0.5,
        subWidth: 0.3,
        subColor: "#666666",
      },
      limitMax: false, // If false, max value increases automatically if value > maxValue
      limitMin: false, // If true, the min value of the gauge will be fixed
      colorStart: "#6FADCF", // Colors
      colorStop: "#8FC0DA", // just experiment with them
      strokeColor: "#E0E0E0", // to see which ones work best for you
      generateGradient: true,
      highDpiSupport: true, // High resolution support
      staticZones: [],
    };
    let target = document.getElementById("gauge_canvas_current_month_id"); // your canvas element

    you_should_be_here = Math.round(you_should_be_here);

    let bereiche = [];

    if (current_month_boli_sold > current_moth_boli_goal) {
      more_than_goal = true;

      let staticLabels = {
        font: "10px sans-serif", // Specifies font
        labels: [], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      };

      var faktor = current_moth_boli_goal < 2000 ? 100 : 1000;

      if (current_moth_boli_goal > 10000) {
        faktor = 2500;
      }

      if (current_moth_boli_goal > 17000) {
        faktor = 5000;
      }

      if (current_moth_boli_goal > 50000) {
        faktor = 12500;
      }

      if (current_moth_boli_goal > 70000) {
        faktor = 25000;
      }

      if (current_moth_boli_goal > 100000) {
        faktor = 50000;
      }

      var extra_max = Math.ceil(current_month_boli_sold / 1000) * 1000;

      if (faktor > 1000) {
        extra_max = Math.ceil(current_month_boli_sold / faktor) * faktor;
      }

      var x = 0;
      var count_x = 0;
      while (x <= extra_max) {
        staticLabels["labels"].push(x);
        x = x + faktor;
        count_x = count_x + 1;
      }
      staticLabels["labels"].push(x);

      opts_herdcoverage["renderTicks"]["divisions"] = count_x > 1 ? count_x - 1 : 1;

      opts_herdcoverage["staticLabels"] = staticLabels;

      bereiche.push({ strokeStyle: "#03fcf4", min: 0, max: you_should_be_here });
      bereiche.push({ strokeStyle: sold_enough ? "#268026" : "#990e05", min: you_should_be_here, max: current_moth_boli_goal });
      bereiche.push({ strokeStyle: "#22e610", min: current_moth_boli_goal, max: current_month_boli_sold });
      bereiche.push({ strokeStyle: "#FFFFFF", min: current_month_boli_sold, max: extra_max });

      opts_herdcoverage["staticZones"] = bereiche;
      var gauge = new Gauge(target).setOptions(opts_herdcoverage); // create sexy gauge!
      gauge.maxValue = extra_max; // set max gauge value
      gauge.setMinValue(0); // Prefer setter over gauge.minValue = 0
      gauge.animationSpeed = 32; // set animation speed (32 is default value)
      gauge.set(current_month_boli_sold); // set actual value
    } else {
      more_than_goal = false;

      let staticLabels = {
        font: "10px sans-serif", // Specifies font
        labels: [], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      };

      var faktor = current_moth_boli_goal < 2000 ? 100 : 1000;

      if (current_moth_boli_goal > 10000) {
        faktor = 2500;
      }

      if (current_moth_boli_goal > 17000) {
        faktor = 5000;
      }

      if (current_moth_boli_goal > 50000) {
        faktor = 12500;
      }

      if (current_moth_boli_goal > 70000) {
        faktor = 25000;
      }

      if (current_moth_boli_goal > 100000) {
        faktor = 50000;
      }

      var extra_max = Math.ceil(current_moth_boli_goal / 1000) * 1000;

      if (faktor > 1000) {
        extra_max = Math.ceil(current_moth_boli_goal / faktor) * faktor;
      }

      var x = 0;
      var count_x = 0;
      while (x <= extra_max) {
        staticLabels["labels"].push(x);
        x = x + faktor;
        count_x = count_x + 1;
      }
      staticLabels["labels"].push(x);
      opts_herdcoverage["renderTicks"]["divisions"] = count_x > 1 ? count_x - 1 : 1;

      opts_herdcoverage["staticLabels"] = staticLabels;

      // console.log('hier2222');
      bereiche.push({ strokeStyle: "#03fcf4", min: 0, max: you_should_be_here });
      bereiche.push({ strokeStyle: sold_enough ? "#268026" : "#990e05", min: you_should_be_here, max: current_moth_boli_goal });

      bereiche.push({
        strokeStyle: "#FFFFFF",
        min: current_moth_boli_goal,
        max: extra_max + (extra_max < current_moth_boli_goal ? 250 : 0),
      });

      // console.log('bereiche: ', bereiche);
      opts_herdcoverage["staticZones"] = bereiche;
      var gauge = new Gauge(target).setOptions(opts_herdcoverage); // create sexy gauge!

      gauge.maxValue = extra_max; // set max gauge value
      gauge.setMinValue(0); // Prefer setter over gauge.minValue = 0
      gauge.animationSpeed = 32; // set animation speed (32 is default value)
      gauge.set(current_month_boli_sold); // set actual value
    }
  }

  async function log_auth() {
    let auth = authenticate(get_register_url(), build_options()).then(function (result) {
      if (result) {
        u_n = u_n.toLowerCase();

        console.log("different_user_view_u_n: ", different_user_view_u_n);

        if (
          different_user_view_u_n &&
          (u_n == "stefan.buerscher@smaxtec.com" ||
            u_n == "ghaith.rahmooni@smaxtec.com" ||
            u_n == "hardani.maulana@smaxtec.com" ||
            u_n == "simon.fischer@smaxtec.com")
        ) {
          u_n = different_user_view_u_n;
          console.log("DIFFERENT USER WIRD GESETZT: ", different_user_view_u_n);
        }

        console.log("u_n: ", u_n);

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_marketing_goals/").then((response) =>
          response.json().then(async function (data) {
            console.log("marketing_goals: ", data);
            if (data.length > 0) {
              marketing_goals_sheet = data;
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_sale_order/").then((response) =>
          response.json().then(async function (data) {
            console.log("sale_order api: ", data);
            if (data) {
              sale_order_all = data["data_json"];
              updated_sale_order = new Date(data["last_updated"]);
            }
          })
        );

        // getByUrlWithThen(get_ip_address_prefix() + '/rest/api_sale_order_current_year/').then((response) =>
        //   response.json().then(async function (data) {
        //     console.log('sale_order api current year: ', data);
        //   })
        // );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_crm_lead/").then((response) =>
          response.json().then(async function (data) {
            if (data) {
              crm_lead_all = data["data_json"];
              updated_crm_lead = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_mail_activity/").then((response) =>
          response.json().then(async function (data) {
            if (data) {
              mail_activity_all = data["data_json"];
              updated_mail_activity = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_res_partner/").then((response) =>
          response.json().then(async function (data) {
            if (data) {
              res_partner_all = data["data_json"];
              updated_res_partner = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_messenger_res/").then((response) =>
          response.json().then(async function (data) {
            if (data) {
              messenger_res = data["data_json"];
              updated_messenger_res = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_sales_price_null/").then((response) =>
          response.json().then(async function (data) {
            if (data) {
              sales_price_null_original = data["data_json"];
              updated_sales_price_null = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_sold_boluses/").then((response) =>
          response.json().then(async function (data) {
            if (data.length > 0) {
              sold_boluses = data;
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_laender_dict/").then((response) =>
          response.json().then(async function (data) {
            if (data.length > 0) {
              laender_dict = JSON.parse(data[0]["json_data"]);
              console.log("Länderdict gesetzt: ", laender_dict);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_allow_lists/" + u_n).then((response) =>
          response.json().then(async function (data) {
            console.log("sale_order api current year: ", data);
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_crm_lead/").then((response) =>
          response.json().then(async function (data) {
            console.log("crm_lead api: ", data);
            if (data) {
              crm_lead_all = data["data_json"];
              updated_crm_lead = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_mail_activity/").then((response) =>
          response.json().then(async function (data) {
            console.log("mail_activity api: ", data);
            if (data) {
              mail_activity_all = data["data_json"];
              updated_mail_activity = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_res_partner/").then((response) =>
          response.json().then(async function (data) {
            console.log("res_partner api: ", data);
            if (data) {
              res_partner_all = data["data_json"];
              updated_res_partner = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_messenger_res/").then((response) =>
          response.json().then(async function (data) {
            console.log("messenger_res api: ", data);
            if (data) {
              messenger_res = data["data_json"];
              updated_messenger_res = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_sales_price_null/").then((response) =>
          response.json().then(async function (data) {
            console.log("sales_price_null api: ", data);
            if (data) {
              sales_price_null_original = data["data_json"];
              updated_sales_price_null = new Date(data["last_updated"]);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_laender_dict/").then((response) =>
          response.json().then(async function (data) {
            console.log("api_laender_dict: ", data);
            if (data.length > 0) {
              laender_dict = JSON.parse(data[0]["json_data"]);
              console.log("Länderdict gesetzt: ", laender_dict);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_allow_lists/" + u_n).then((response) =>
          response.json().then(async function (data) {
            see_all_in_sales = data["allow"];
            if (data["see_only_marketing"]) {
              see_only_marketing = true;
              show_main_content = false;
            }

            ghais_special_access = data["ghais_special_access"];
            in_show_marketing_nav_item = data["in_show_marketing_nav_item"];
            in_show_market_nav_item = data["in_show_market_nav_item"];
            in_show_management_nav_item = data["in_show_management_nav_item"];
            in_show_sales_dashboard = data["in_show_sales_dashboard"];
            allow_refresh_list = data["allow_refresh_list"];
            group_rights = data["group_rights"];
            if (data["individual_rights"]) {
              individual_rights = data["individual_rights"].map((name) => format_name(name));
            }
            see_only_map = data["see_only_map"];
            see_individual_countries = data["see_individual_countries"];
            in_show_helptext_id = data["in_show_helptext_id"];

            console.log("individual_rights: ", individual_rights);

            if (individual_rights) {
              individual_rights.forEach((individual_sales_access) => {
                console.log("push: ", individual_sales_access);
                salesman_selected.push(individual_sales_access);
              });
            }
            // Update sales teams only after allow lists finished
            get_sales_teams();
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_all_dashboard_dataframe/all/").then((response) =>
          response.json().then(async function (data) {
            special_access = data["xsau"];
            goals_all = data["xgoals_all"];
            // crm_lead_all = data['xcrm_lead'];
            // mail_activity_all = data['xmail_activity'];
            lost_opportunities_all = data["xlost_opportunities"];
            // res_partner_all = data['xres_partner'];
            // sale_order_all = data['xsale_order'];
            marketing_team = data["xmarketingteams"];
            marketing_team.push("stefan.buerscher@smaxtec.com");
            subscription_all = data["xsale_subscription"];
            lost_leads = data["xlost_leads"];
            // insights = data['xinsights'];
            insights = false;
            archived = data["xarchived"];
            // messenger_res = data['xmessenger_res'];
            // sales_price_null_original = data['xsales_price_null'];
            activated_all = data["xactivated"];
            marketing_goals = data["xmarketing_goals"];
            cust_goals_all = data["xcust_goals_all"];
            revenue = data["xrevenue"];
            aco_cost = data["xaco_cost"];
            goal_revenue = data["xgoal_revenue"];
            monthly_cost = data["xmonthly_cost"];
            clv_targets = data["xclv_targets"];
            x_team_country_dashboard = data["xx_team_country_dashboard"];

            updated_goals_all = new Date(data["xupdated_goals_all"]);
            updated_cust_goals_all = new Date(data["xupdated_cust_goals_all"]);
            // updated_crm_lead = new Date(data['xupdated_crm_lead']);
            // updated_mail_activity = new Date(data['xupdated_mail_activity']);
            updated_lost_opportunities = new Date(data["xupdated_lost_opportunities"]);
            // updated_res_partner = new Date(data['xupdated_res_partner']);
            // updated_sale_order = new Date(data['xupdated_sale_order']);
            updated_marketingteams = new Date(data["xupdated_marketingteams"]);
            updated_sale_subscription = new Date(data["xupdated_sale_subscription"]);
            updated_lost_leads = new Date(data["xupdated_lost_leads"]);
            updated_salesteams = new Date(data["xupdated_salesteams"]);
            updated_marketing_goals = new Date(data["xupdated_marketing_goals"]);
            updated_archived = new Date(data["xupdated_archived"]);
            // updated_messenger_res = new Date(data['xupdated_messenger_res']);
            // updated_sales_price_null = new Date(data['xupdated_sales_price_null']);
            updated_activated = new Date(data["xupdated_activated"]);
            updated_revenue = new Date(data["xupdated_revenue"]);
            updated_aco_cost = new Date(data["xupdated_aco_cost"]);
            updated_goal_revenue = new Date(data["xupdated_goal_revenue"]);
            updated_monthly_cost = new Date(data["xupdated_monthly_cost"]);
            updated_clv_targets = new Date(data["xupdated_clv_targets"]);
            updated_power_chart = new Date(data["xupdated_power_chart"]);

            if (u_n == "maria.leitner@smaxtec.com" || u_n == "hardani.maulana@smaxtec.com" || u_n == "astrid.schluenken@elevation.at") {
              console.log("-----------------------");
              console.log("Data Tables for Astrid:");
              console.log("crm_lead_all: ", crm_lead_all);
              console.log("mail_activity_all: ", mail_activity_all);
              console.log("lost_opportunities_all: ", lost_opportunities_all);
              console.log("res_partner_all: ", res_partner_all);
              console.log("sale_order_all: ", sale_order_all);
              console.log("marketing_team: ", marketing_team);
              console.log("subscription_all: ", subscription_all);
              console.log("lost_leads: ", lost_leads);
              console.log("insights: ", insights);
              console.log("archived: ", archived);
              console.log("messenger_res: ", messenger_res);
              console.log("sales_price_null_original: ", sales_price_null_original);
              console.log("activated_all: ", activated_all);
              console.log("marketing_goals: ", marketing_goals);
              console.log("goals_all: ", goals_all);
              console.log("cust_goals_all: ", cust_goals_all);
              console.log("revenue: ", revenue);
              console.log("aco_cost: ", aco_cost);
              console.log("goal_revenue: ", goal_revenue);
              console.log("monthly_cost: ", monthly_cost);
              console.log("clv_targets: ", clv_targets);
              console.log("x_team_country_dashboard: ", x_team_country_dashboard);
              console.log("special_access: ", special_access);
              console.log("u_n: ", u_n);
              console.log("-----------------------");
            }

            if (u_n == "stefan.buerscher@smaxtec.com" || u_n == "hardani.maulana@smaxtec.com") {
              console.log("updated_goals_all: ", updated_goals_all);
              console.log("updated_cust_goals_all: ", updated_cust_goals_all);
              console.log("updated_crm_lead: ", updated_crm_lead);
              console.log("updated_mail_activity: ", updated_mail_activity);
              console.log("updated_lost_opportunities: ", updated_lost_opportunities);
              console.log("updated_res_partner: ", updated_res_partner);
              console.log("updated_sale_order: ", updated_sale_order);
              console.log("updated_marketingteams: ", updated_marketingteams);
              console.log("updated_sale_subscription: ", updated_sale_subscription);
              console.log("updated_lost_leads: ", updated_lost_leads);
              console.log("updated_salesteams: ", updated_salesteams);
              console.log("updated_marketing_goals: ", updated_marketing_goals);
              console.log("updated_archived: ", updated_archived);
              console.log("updated_messenger_res: ", updated_messenger_res);
              console.log("updated_sales_price_null: ", updated_sales_price_null);
              console.log("updated_activated: ", updated_activated);
              console.log("updated_revenue: ", updated_revenue);
              console.log("updated_aco_cost: ", updated_aco_cost);
              console.log("updated_goal_revenue: ", updated_goal_revenue);
              console.log("updated_monthly_cost: ", updated_monthly_cost);
              console.log("updated_clv_targets: ", updated_clv_targets);
            }
          })
        );

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_helptexts/").then((response) =>
          response.json().then(async function (data) {
            console.log("helptexts: ", data);
            helptexts = data;
          })
        );
      }
    });

    try {
      await auth;
    } catch (error) {
      console.log(error);
      console.log("Login failed");
      login_isOpen = true;
      login_failed = true;
    }
  }

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }

  async function get_sales_teams() {
    getByUrlWithThen(get_ip_address_prefix() + "/rest/api_dashboard_dataframe/salesteams/").then((response) =>
      response.json().then(async function (data) {
        // data['data_json'].splice(2, 1);

        array_move(data["data_json"], 2, 4);

        let salesteams_all_tmp = data["data_json"];
        let sales_teams_dict = {};

        ex_sales_persons = [];

        while (!special_access) {
          await new Promise((r) => setTimeout(r, 100));
          // console.log('sleep');
        }
        // console.log('SPECIAL ACCES ANSCHEINEND GELADEN');

        var i = 0;
        for (var key in salesteams_all_tmp[0]) {
          // while(i < .length){
          // console.log("salesteams_all_tmp[0][i]: ", salesteams_all_tmp[0][i])
          sales_teams_dict[salesteams_all_tmp[0][key]] = { members: [], teamname: key };
          var teamleader = salesteams_all_tmp[2][key];
          var teamleadermail = salesteams_all_tmp[3][key]["login"];

          sales_teams_dict[salesteams_all_tmp[0][key]]["teamleader"] = teamleader;
          sales_teams_dict[salesteams_all_tmp[0][key]]["teamleadermail"] = teamleadermail;

          var x = 0;
          while (x < salesteams_all_tmp[1][salesteams_all_tmp[0][key]].length) {
            var salesman = salesteams_all_tmp[1][salesteams_all_tmp[0][key]][x]["name"];
            sales_teams_dict[salesteams_all_tmp[0][key]]["members"].push(salesman);
            x = x + 1;
          }

          x = 0;
          while (x < salesteams_all_tmp[4][salesteams_all_tmp[0][key]].length) {
            var salesman = salesteams_all_tmp[4][salesteams_all_tmp[0][key]][x]["name"];
            sales_teams_dict[salesteams_all_tmp[0][key]]["members"].push(salesman);
            ex_sales_persons.push(salesman);
            x = x + 1;
          }

          i = i + 1;
        }

        let unfiltered = [];
        let add_groups = [];

        for (var key in sales_teams_dict) {
          unfiltered.push(sales_teams_dict[key]);
        }
        sales_teams_unfiltered = unfiltered;

        // console.log("sales_teams_unfiltered: ", sales_teams_unfiltered)
        // console.log("sales_teams_dict anfang: ", sales_teams_dict)

        //filtern
        if (see_all_in_sales) {
          let filtered = [];
          for (var key in sales_teams_dict) {
            filtered.push(sales_teams_dict[key]);
          }
          salesteams_all = filtered;
        } else {
          let filtered = [];
          for (var key in sales_teams_dict) {
            if (sales_teams_dict[key]["teamleadermail"] == u_n) {
              filtered.push(sales_teams_dict[key]);
              is_teamleader = true;
              selected_team = key;
            } else if (JSON.stringify(group_rights) != "{}") {
              if (group_rights[u_n].includes(key)) {
                add_groups.push(sales_teams_dict[key]);
              }
            } else {
              if (u_n in see_only_map && (see_map_team(see_only_map, u_n, key) || selected_team == "ALL")) {
                filtered.push(sales_teams_dict[key]);
              }
            }
          }

          if (u_n in see_only_map) {
            catch_first_salesman_country = 0;
            if (selected_team == "ALL" || see_map_team(see_only_map, u_n, "ALL")) {
              see_all_in_sales = true;
              select_all();
            } else {
              select_team(filtered[0]["members"] || [], see_only_map[u_n][0]);
            }
          }

          // console.log('special_access: ', special_access);
          for (var key in special_access) {
            // console.log('special_a: ', special_access[key]);
            if (special_access[key]["login"] == u_n) {
              if (!filtered.includes(special_access[key]["team"])) {
                var find_team = false;

                for (var t in sales_teams_dict) {
                  if (special_access[key]["team"] == sales_teams_dict[t]["teamname"]) {
                    find_team = sales_teams_dict[t];
                  }
                }
                if (find_team) {
                  filtered.push(find_team);
                  has_special_access = true;
                }
              }
            }
          }

          // remove duplicates team from the array
          const filtered_non_duplicate = Array.from(new Set(filtered));
          salesteams_all = filtered_non_duplicate;
        }

        checked_special_access = true;
        // console.log('salesteams_all: ', salesteams_all);

        getByUrlWithThen(get_ip_address_prefix() + "/rest/api_dashboard_dataframe/powerchart/").then((response) =>
          response.json().then(async function (data) {
            power_chart_data = data["data_json"];
            power_chart_data_salesman_index = data["data_json_index"];
            power_chart_data_salesman_index.sort();

            // console.log("power_chart_data: ", power_chart_data)
            // console.log("power_chart_data_salesman_index: ", power_chart_data_salesman_index)
            var year = new Date().getFullYear();
            if (year_filter != "ALL") {
              year = year_filter;
            }
            // console.log("year vor POWERCXHAT: ", year)
            var tmp = calculate_powerchart_over_year_ranks(power_chart_data, power_chart_data_salesman_index, year);
            over_year_ranks = tmp["ranks"];
            pcline = tmp["pcline"];

            // console.log('calculate_powerchart_over_year_ranks: ', tmp);

            // console.log("pcline: ", pcline)

            // console.log("over_year_ranks: ", over_year_ranks)

            let found = false;

            while (!checked_special_access) {
              await new Promise((r) => setTimeout(r, 100));
              // console.log('sleep');
            }

            // console.log('CHECKED SPECIAL ACCES!');

            // console.log('u_n.toLowerCase(): ', u_n.toLowerCase());

            u_n = u_n.toLowerCase();
            // u_n = 'astrid.schluenken@elevation.at'

            if (see_only_marketing) {
              finished_get_power_chart_data = true;
              // console.log('finished_get_power_chart_data 2928');
            }

            // add all additional accessible group without put it in initial data visualization
            salesteams_all = salesteams_all.concat(add_groups);

            if ((is_teamleader || has_special_access) && !see_all_in_sales) {
              salesteams_all.forEach((s) => {
                var members = s["members"];

                members.forEach((m) => {
                  if (power_chart_data_salesman_index.includes(m) && m != "Chris Howarth") {
                    team_members.push(m);
                  }
                });
                // console.log('team_members: ', team_members);
                team_members = team_members.sort();
                salesman_selected = team_members;
              });
            }

            //Meinen Namen auslesen (aus Powerchart):
            for (const [, sales_entry] of Object.entries(power_chart_data)) {
              for (const [, month_entry] of Object.entries(sales_entry)) {
                // console.log("month_entry['mail']: ", month_entry['mail'])
                var month_entry_mail_tmp = month_entry["mail"];
                // console.log("month_entry: ", month_entry)
                // console.log("month_entry_mail_tmp: ", month_entry_mail_tmp)
                // console.log("salesman_index: ", salesman_index)
                month_entry_mail_tmp = month_entry_mail_tmp.toLowerCase();
                u_n_tmp = u_n.toLowerCase();
                if (month_entry_mail_tmp == u_n) {
                  mein_name = month_entry["name"];
                }
              }
            }

            if (!see_all_in_sales && has_special_access) {
            }

            if (!see_all_in_sales && !has_special_access) {
              //get name from powerchart:
              for (const [, sales_entry] of Object.entries(power_chart_data)) {
                // console.log(salesman_index);

                if (!found) {
                  for (const [, month_entry] of Object.entries(sales_entry)) {
                    // console.log("month_entry['mail']: ", month_entry['mail'])
                    var month_entry_mail_tmp = month_entry["mail"];
                    var u_n_tmp = u_n;

                    month_entry_mail_tmp = month_entry_mail_tmp.toLowerCase();
                    u_n_tmp = u_n_tmp.toLowerCase();

                    // console.log("month_entry_mail_tmp: ", month_entry_mail_tmp)
                    // console.log("u_n_tmp: ", u_n_tmp)

                    if (month_entry_mail_tmp == u_n_tmp) {
                      found = true;
                      let name = month_entry["name"];
                      if (!salesteams_all) {
                        salesman_selected_single = name;
                      }
                      // if (!subscription_all) {

                      finished_get_power_chart_data = true;
                      console.log("finished_get_power_chart_data");
                      // }
                      break;
                    }
                  }
                }
                if (found) {
                  //console.log('continue outer');
                  break;
                }
              }
            } else {
              power_chart_data_salesman_index.push("Others");

              finished_get_power_chart_data = true;
              console.log("finished_get_power_chart_data Others");
              select_all();
            }

            if (finished_get_power_chart_data != true) {
              if (u_n == "michael.goeldi@smaxtec.com" || (u_n == "matthias.kehrer@smaxtec.com" && selected_team == "ALL")) {
                salesteams_all.forEach((s) => {
                  var members = s["members"];

                  members.forEach((m) => {
                    if (power_chart_data_salesman_index.includes(m) && m != "Chris Howarth") {
                      team_members.push(m);
                    }
                  });
                  // console.log('team_members: ', team_members);
                  team_members = team_members.sort();
                  salesman_selected = team_members;
                });
              }

              finished_get_power_chart_data = true;
              no_user_found = true;
            }
          })
        );
      })
    );
  }

  function click_extra_row_1() {
    show_extra_boli_1 = !show_extra_boli_1;
  }

  function select_all() {
    if (u_n in see_only_map) {
      if (see_only_map[u_n].includes("ALL")) {
        selected_team = "ALL";
        salesman_selected_single = [];
        if (power_chart_data_salesman_index) {
          salesman_selected = power_chart_data_salesman_index;
        }
      }
    } else if (group_rights) {
      if (!selected_team) {
        if (group_rights[u_n].includes("ALL")) {
          selected_team = "ALL";
          salesman_selected_single = [];
          if (power_chart_data_salesman_index) {
            salesman_selected = power_chart_data_salesman_index;
          }
        } else {
          salesteams_all.forEach((salesteam) => {
            if (salesteam["members"].includes(mein_name)) {
              select_team(salesteam["members"], salesteam["teamname"]);
            }
          });
        }
      } else {
        selected_team = "ALL";
        salesman_selected_single = [];
        if (power_chart_data_salesman_index) {
          salesman_selected = power_chart_data_salesman_index;
        }
      }
    } else {
      selected_team = "ALL";
      salesman_selected_single = [];
      if (power_chart_data_salesman_index) {
        salesman_selected = power_chart_data_salesman_index;
      }
    }
  }

  function select_team(team, team_name) {
    console.log("team: ", team);
    console.log("team_name: ", team_name);
    if (country_selected.length > 0) {
      country_selected = [];
    }
    selected_team = team_name;
    salesman_selected_single = [];
    salesman_selected = team;
  }

  function refresh() {
    console.log("refresh button clicked");
    while_refreshing_text = "Refresh process started. This can take up to 5 minutes...";
    getByUrlWithThen(get_ip_address_prefix() + "/rest/api_recalculate/or3/").then((response) =>
      response.json().then(async function (data) {
        console.log("response from refresh: ", data);
        refresh_finished_text = "Refresh Done on Server. Reloading data in progress...";
        while_refreshing_text = "";
        // finished_get_data = false;

        goals_all = false;
        crm_lead_all = false;
        mail_activity_all = false;
        subscription_all = false;
        res_partner_all = false;
        sale_order_all = false;
        lost_opportunities_all = false;
        finished_get_power_chart_data = false;

        log_auth();
      })
    );
  }

  function build_options() {
    console.log("in build_options: ", u_n.toLowerCase());

    let options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: u_n.toLowerCase(),
        password: p_w,
      }),
    };
    return options;
  }

  //resets From Date to start of current Year.

  function toggleCheckbox(e) {
    // leads_older_three_days_table['values'] = leads_older_three_days_table_before_last_filter['values']
    var source = e.target.id;
    var checked = e.target.checked;

    list_of_sources_dict[source] = checked;
    let filtered = [];
    leads_older_three_days_table_before_last_filter.forEach((element) => {
      var s = element["source"];
      if (list_of_sources_dict[s]) {
        filtered.push(element);
      }
    });
    leads_older_three_days_table["values"] = filtered;

    filtered = [];

    leads_offen_table_cpy_values.forEach((element) => {
      var s = element["source_id"];
      if (list_of_sources_dict[s]) {
        filtered.push(element);
      }
    });
    leads_offen_table["values"] = filtered;

    // Set the other checkboxes correctly
    var items = document.getElementsByClassName(source);
    let numItems = items.length;
    for (let i = 0; i < numItems; i++) {
      items[i].checked = checked;
    }
  }

  function deal_with_ex_sales_persons(array, ex_sales) {
    var tmp_array = [];
    for (let i = 0; i < array.length; i++) {
      if (show_inactive_sales) {
        tmp_array.push(array[i]);
      } else {
        if (!ex_sales.includes(array[i])) {
          tmp_array.push(array[i]);
        }
      }
    }

    // console.log('without ex: ', tmp_array);

    return tmp_array;
  }

  function getEarliestDate(dateArray) {
    if (dateArray) {
      return new Date(Math.min.apply(null, dateArray));
    } else {
      return new Date();
    }
    // Use the apply method to pass the array elements as individual arguments to Math.min
  }

  function isDateWithinLast5Hours(dateToCheck) {
    var d;

    if (Array.isArray(dateToCheck)) {
      d = getEarliestDate(dateToCheck);
    } else {
      d = dateToCheck;
    }

    return new Date() - d <= 1000 * 60 * 60 * 5;
  }

  function set_year_filter(year) {
    // console.log('set_year_filter');
    year_filter = year;
    if (
      goals_all &&
      crm_lead_all &&
      mail_activity_all &&
      res_partner_all &&
      sale_order_all &&
      finished_get_power_chart_data &&
      lost_opportunities_all &&
      subscription_all &&
      sales_price_null_original &&
      salesteams_all &&
      messenger_res &&
      activated_all &&
      marketing_goals &&
      cust_goals_all
    ) {
      do_all_calculations();
    }
    redraw = false;
    redraw = true;
  }

  function remove_salesman_melani() {
    // console.log('Remove Salesman');
    select_all();
    // country_selected = 'Switzerland';
    if (u_n in see_individual_countries && !JSON.stringify(group_rights) != "{}" && !see_all_in_sales) {
      country_selected = see_individual_countries[u_n][0];
    }
  }

  function remove_salesman() {
    if (group_rights) {
      if (!selected_team || selected_team == "ALL") {
        if (group_rights[u_n].includes("ALL")) {
          select_all();
        } else {
          salesteams_all.forEach((salesteam) => {
            if (salesteam["members"].includes(mein_name)) {
              selected_team = salesteam["teamname"];
            }
          });
        }
      } else {
        salesteams_all.forEach((salesteam) => {
          if (salesteam["teamname"] == selected_team) {
            select_team(salesteam["members"], salesteam["teamname"]);
          }
        });
      }
    }
  }

  function remove_country() {
    if (JSON.stringify(see_individual_countries) === "{}") {
      if (group_rights) {
        if (!selected_team) {
          country_selected = [];
          select_all();
        } else {
          salesteams_all.forEach((salesteam) => {
            if (salesteam["teamname"] == selected_team) {
              select_team(salesteam["members"], salesteam["teamname"]);
            }
          });
        }
      }
    } else if (see_individual_countries[u_n].length == 1) {
      country_selected = see_individual_countries[u_n][0];
    } else {
      country_selected = [];
      if (group_rights) {
        if (!selected_team) {
          if (group_rights[u_n].includes("ALL")) {
            select_all();
          } else {
            selected_team = group_rights[u_n][0];
          }
        } else {
          salesteams_all.forEach((salesteam) => {
            if (salesteam["teamname"] == selected_team) {
              select_team(salesteam["members"], salesteam["teamname"]);
            }
          });
        }
      } else {
        country_selected = country_list[0];
      }
    }

    // if (u_n == 'melanie.singer@smaxtec.com') {
    //   if (salesman_selected_single == []) {
    //     salesman_selected_single = 'Melanie Singer';
    //   }
    // }
  }

  function check_if_show_only_map(salesman_selected, selected_team) {
    if (Object.keys(see_only_map).length == 0) {
      console.log("see NOT only map!");
      return false;
    }

    if (!(u_n in see_only_map)) {
      console.log("see NOT only map!");
      return false;
    }

    console.log("see ONLY map!");
    return u_n in see_only_map && see_map_team(see_only_map, u_n, selected_team);
  }
  function see_map_team(see_only_map, username, team) {
    if (username in see_only_map) {
      if (see_only_map[username].includes(team)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
</script>

{#if !no_user_found || u_n in see_only_map || individual_rights || see_individual_countries}
  <nav
    class="navbar sticky-top navbar-expand navbar-light navbar-bg {show_main_content === true && !see_only_marketing
      ? 'div'
      : 'hiddenClass'}"
  >
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              {#if redraw_after_check_ex_sales}
                {#if see_all_in_sales && all_loaded && !check_if_show_only_map(u_n, selected_team)}
                  {#if power_chart_data_salesman_index}
                    <b>Select Salesperson</b>
                    <MultiSelect
                      on:remove={remove_salesman}
                      bind:selected={salesman_selected_single}
                      options={deal_with_ex_sales_persons(power_chart_data_salesman_index, ex_sales_persons)}
                      maxSelect={1}
                    />
                  {/if}

                  {#if country_list}
                    <b>Select Country</b>

                    <MultiSelect on:remove={remove_country} bind:selected={country_selected} options={country_list.sort()} maxSelect={1} />
                  {/if}
                {/if}

                {#if see_individual_countries}
                  {#if u_n in see_individual_countries}
                    <b>Select Country</b>
                    <MultiSelect
                      on:remove={remove_country}
                      bind:selected={country_selected}
                      options={see_individual_countries[u_n].sort()}
                      maxSelect={1}
                    />
                  {/if}
                {/if}

                <!-- {#if u_n == 'melanie.singer@smaxtec.com'}
                  <b>Select Country</b>
                  <MultiSelect on:remove={remove_country} bind:selected={country_selected} options={['Switzerland']} maxSelect={1} />
                {/if} -->

                {#if !individual_rights && !see_all_in_sales && salesman_selected.length > 0 && !is_teamleader && !has_special_access && mein_name}
                  <b>Sales Mirror for:</b>
                  {mein_name}
                  <!-- <div on:click={remove_self}>🗙</div> -->
                {/if}

                {#if !see_all_in_sales && salesman_selected.length > 0 && (is_teamleader || has_special_access || individual_rights)}
                  {#if individual_rights && !is_teamleader}
                    <b>Select Salesperson</b>
                    <MultiSelect
                      on:remove={remove_salesman}
                      bind:selected={salesman_selected_single}
                      options={individual_rights}
                      maxSelect={1}
                    />
                  {/if}

                  {#if individual_rights && is_teamleader}
                    <b>Select Salesperson</b>
                    <MultiSelect
                      on:remove={remove_salesman}
                      bind:selected={salesman_selected_single}
                      options={[].concat(deal_with_ex_sales_persons(team_members, ex_sales_persons), individual_rights)}
                      maxSelect={1}
                    />
                  {/if}

                  {#if !individual_rights && is_teamleader}
                    <b>Select Salesperson</b>
                    <MultiSelect
                      on:remove={remove_salesman}
                      bind:selected={salesman_selected_single}
                      options={deal_with_ex_sales_persons(team_members, ex_sales_persons)}
                      maxSelect={1}
                    />
                  {/if}
                {/if}
              {/if}

              {#if all_loaded && (see_all_in_sales || is_teamleader) && !check_if_show_only_map(u_n, selected_team)}
                <div class="row" style="margin-left: 2px;">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      style="width:9px; height:9px; margin-top:9px; "
                      bind:checked={show_inactive_sales}
                      value=""
                      id="flexCheckDefault49"
                    />
                    <label class="form-check-label" style="white-space: nowrap;" for="flexCheckDefault49']}">
                      <b>Show Inactive Sales Persons in Selection List</b>
                    </label>
                  </div>
                </div>
              {/if}
            </div>
            <!-- <div class="col">
            {#if allow_refresh_list.includes(u_n)}
              <button class="btn" on:click={refresh}>REFRESH</button>
              {refresh_finished_text}{while_refreshing_text}
            {/if}

          </div> -->

            <div class="col">
              {#if salesteams_all}
                {#if salesteams_all.length > 0}
                  <div class="row">
                    <b>Sales Teams</b>
                  </div>

                  <div class="row">
                    <div class="btn-group py-2">
                      {#if (see_all_in_sales || see_map_team(see_only_map, u_n, "ALL")) && !(u_n in see_individual_countries)}
                        <button on:click={select_all} class="btn {selected_team === 'ALL' ? 'active' : ''}">ALL</button>
                      {/if}
                      {#each salesteams_all as salesteam}
                        <!-- <div class="col"> -->
                        <button
                          on:click={select_team(salesteam["members"], salesteam["teamname"])}
                          class="btn {selected_team === salesteam['teamname'] ? 'active' : ''}">{salesteam["teamname"]}</button
                        >
                        <!-- </div> -->
                      {/each}
                    </div>
                  </div>
                {/if}
              {/if}
            </div>
            <div class="col">
              {#if year_buttons}
                <div class="row">
                  <b>Select Year</b>
                </div>
                <div class="flex-row">
                  <div class="btn-group py-2">
                    <button on:click={() => set_year_filter("ALL")} class="btn {year_filter === 'ALL' ? 'active' : ''}">ALL</button>
                    {#each year_buttons as b}
                      <button on:click={() => set_year_filter(b)} class="btn {year_filter === b ? 'active' : ''}">{b}</button>
                    {/each}
                  </div>
                  {#if all_loaded && !check_if_show_only_map(u_n, selected_team) && JSON.stringify(group_rights) != "{}"}
                    <Modal>
                      <Content
                        {export_excel}
                        {export_weekly_excel}
                        {u_n}
                        {year_buttons}
                        salesteams_all={sales_teams_unfiltered}
                        {mein_name}
                        {group_rights}
                        {ghais_special_access}
                        {individual_rights}
                        origin_all_sales_members={power_chart_data_salesman_index}
                      />
                    </Modal>
                  {/if}
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
{/if}

<main class="content {show_main_content === true && !see_only_marketing ? 'div' : 'hiddenClass'}">
  <div class="container-fluid p-0">
    <!-- {#if do_all_calculations_finished} -->
    <!-- {#if !no_user_found && !check_if_show_only_map(salesman_selected, selected_team)} -->
    <div
      class="row {(!no_user_found || individual_rights || see_individual_countries) &&
      !check_if_show_only_map(salesman_selected, selected_team)
        ? ''
        : 'hiddenClass'}"
    >
      <div class="row">
        <h4>My Sales</h4>

        <div class="mb-0">
          <span class="text" />
        </div>
      </div>

      <div class="row">
        <div class="col-xl-8 col-xxl-8">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Sold BOLUSES compared to targets {#if !isDateWithinLast5Hours(updated_sale_order)}(last data update: ~{formatDateAndHours(
                    updated_sale_order
                  )}){/if}
              </h5>

              <div class="custom-control custom-switch" style="margin-right: 20px;">
                <input bind:checked={show_ph_boli} type="checkbox" class="custom-control-input" id="customSwitch1" />
                <label class="custom-control-label" for="customSwitch1">Show pH</label>
              </div>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_sold_boluses")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_sold_boluses")}
                  {:else}
                    your targets for total count of Sold BOLUSES (including recurring and all boli)
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_sold_boluses</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>
            <div class="card-body">
              {#if !show_ph_boli}
                {#if sold_boli_per_month_linechart_data}
                  <LineChart dataLine={sold_boli_per_month_linechart_data} />
                {/if}
              {:else if sold_ph_boli_per_month_linechart_data}
                <LineChart dataLine={sold_ph_boli_per_month_linechart_data} />
              {/if}
            </div>
          </div>
        </div>

        <div class="col-xl-4 col-xxl-4 d-flex">
          <div class="card h-100 {global_current_moth_boli_goal ? '' : 'x'}">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Yearly Goal {#if !isDateWithinLast5Hours(updated_goals_all)}(last data update: ~{formatDateAndHours(
                    updated_goals_all
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_yearly_goal")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_yearly_goal")}
                  {:else}
                    Annual Target: Achieved Sold BOLUSES (Black pointer ), Target: where you currently have to be to achieve the annual
                    target.
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_yearly_goal</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class={disable_current_month === false ? "div" : "hiddenClassGaunt"}>
                <canvas class="gauge_boli" id="gauge_canvas_current_month_id" />

                <div class="col">
                  <div class="row">
                    <div class="col" align="center">
                      <div id="should_be_here" />
                      target
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col" align="center">
                    <div class={sold_enough === true ? "greendiv" : "reddiv"} />
                    yearly target
                  </div>
                </div>
                <div class="row">&nbsp;</div>
                <div class="row">
                  <div class="col" align="center">
                    <p style="color:#706c6c; font-size:25px;">
                      Boli sold: {sold_boli_sum}
                    </p>
                    <p style="color:#706c6c; font-size:25px;">
                      Yearly Goal: {goals_sum}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                {#if disable_current_month}
                  Missing data. Did you define a goal for the current month?
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-8">
          <div class="card h-100" style="margin-top: 20px;">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Sold BOLUSES compared to targets (invoiced) {#if !isDateWithinLast5Hours(updated_sale_order)}(last data update: ~{formatDateAndHours(
                    updated_sale_order
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_sold_boluses_invoiced")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_sold_boluses_invoiced")}
                  {:else}
                    Sold Boluses that are already invoiced
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_sold_boluses_invoiced</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>
            <div class="card-body">
              {#if sold_boli_per_month_invoiced_linechart_data}
                <LineChart dataLine={sold_boli_per_month_invoiced_linechart_data} />
              {/if}
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="card h-100" style="margin-top: 20px;">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Offers won {#if !isDateWithinLast5Hours(updated_sale_order)}(last data update: ~{formatDateAndHours(
                    updated_sale_order
                  )}){/if}
              </h5>
              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_offers_won")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_offers_won")}
                  {:else}
                    won (in every status); de:Gewonnene Angebote
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_offers_won</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if sold_boli_per_month_angebote_linechart_data}
                <LineChart dataLine={sold_boli_per_month_angebote_linechart_data} />
              {/if}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card" style="padding:20px;">
            <div on:click={click_extra_row_1} class="card-header d-flex justify-content-between align-items-center maus">
              {#if !show_extra_boli_1}
                <b> ▼ </b>
              {:else}
                <b> ▲ </b>
              {/if}
              <h5 class="card-title mb-0">
                Extra Boli Info {#if !isDateWithinLast5Hours(updated_sale_order)}(last data update: ~{formatDateAndHours(
                    updated_sale_order
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_extra_boli_info")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_extra_boli_info")}
                  {:else}
                    Sold Boli grouped by reorder and new
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_extra_boli_info</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>
            <div class="div {show_extra_boli_1 ? 'shownClassRow' : 'hiddenClassRow'}">
              <LineChart dataLine={boli_new_reorder_linechart_data} />
            </div>
          </div>

          <div class="card h-100" style="padding:20px;">
            <div class="card-header d-flex justify-content-between align-items-center">
              {#if show_extra_boli_1}
                <h5 class="card-title mb-0">
                  Sold Boluses with price Null {#if !isDateWithinLast5Hours(updated_sale_order)}(last data update: ~{formatDateAndHours(
                      updated_sale_order
                    )}){/if}
                </h5>

                <div class="info-circle my-auto">
                  <div class="my-auto info-i">i</div>
                  <div class="info-box" style="color: #000000;">
                    {#if find_help_text_if_exists(helptexts, "sales_mirror_price_null")}
                      {@html find_help_text_if_exists(helptexts, "sales_mirror_price_null")}
                    {:else}
                      Sold boluses with price null
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: sales_mirror_price_null</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              {/if}
            </div>

            <div class="card-body div {show_extra_boli_1 ? 'shownClassRow' : 'hiddenClassRow'}">
              <LineChart dataLine={boli_price_null_per_month_linechart_data} />
            </div>
          </div>
        </div>
      </div>

      <div
        class="row {yearly_goal_new_clients && (selected_team == 'USA' || selected_team == 'DACH+' || selected_team == 'DACH')
          ? 'div'
          : 'hiddenClassRow'}"
      >
        <div class="col-xl-8 col-xxl-8 d-flex">
          <div class="card flex-fill">
            <div class="card-header">
              <h5 class="card-title mb-0">
                New Clients compared to targets {#if !isDateWithinLast5Hours(updated_res_partner)}(last data update: ~{formatDateAndHours(
                    updated_res_partner
                  )}){/if}
              </h5>
              {#if new_customers_per_month_linechart_data}
                <LineChart dataLine={new_customers_per_month_linechart_data} />
              {/if}
            </div>
          </div>
          <div class="help">
            <a href="#" style="color: gray;" title="your targets for total count of Sold BOLUSES (including recurring and all boli)">?</a>
          </div>
        </div>

        <div class="col-xl-4 col-xxl-4">
          <div class="card h-100 {global_current_moth_boli_goal ? '' : 'x'}">
            <div class="card-header d-flex">
              <h5 class="card-title mb-0">Yearly Goal</h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_new_clients_to_targets")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_new_clients_to_targets")}
                  {:else}
                    Annual Target: Achieved Sold BOLUSES (Black pointer ), Target: where you currently have to be to achieve the annual
                    target.
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_new_clients_to_targets</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class={yearly_goal_new_clients === 0 ? "hiddenClassGaunt" : "div"}>
                <canvas class="gauge_boli" id="gauge_canvas_new_cust_id" />

                <div class="col">
                  <div class="row">
                    <div class="col" align="center">
                      <div id="should_be_here" />
                      target
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col" align="center">
                    <div class={sold_enough_clients === true ? "greendiv" : "reddiv"} />
                    yearly target
                  </div>
                </div>
                <div class="row">&nbsp;</div>
                <div class="row">
                  <div class="col" align="center">
                    <p style="color:#706c6c; font-size:25px;">
                      New Customers: {current_new_clients}
                    </p>
                    <p style="color:#706c6c; font-size:25px;">
                      Yearly Goal: {yearly_goal_new_clients}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                {#if yearly_goal_new_clients === 0}
                  Missing data. Did you define a goal for the current month?
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-8 col-xxl-8">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                New Clients (by company size) {#if !isDateWithinLast5Hours(updated_res_partner)}(last data update: ~{formatDateAndHours(
                    updated_res_partner
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_new_clients")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_new_clients")}
                  {:else}
                    New Clients by size of herd. (only if herdsize is greater zero)
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_new_clients</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if new_customer_herdsize_linechart_data}
                <CustomLineChart
                  id={1313}
                  line_data={new_customer_herdsize_linechart_data}
                  type={"bar"}
                  bind:salesman_selected
                  bind:redraw
                />
              {/if}
            </div>
          </div>
        </div>

        <div class="col-xl-4 col-xxl-4">
          <div class="row">
            <div class="col">
              <div
                class="card {year_filter == 'ALL' || year_filter.toString() == new Date().getFullYear().toString()
                  ? ''
                  : 'hiddenClassGaunt'}"
              >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="card-title">Herd Coverage: {herd_coverage_percentage}%</h5>

                  <div class="info-circle my-auto">
                    <div class="my-auto info-i">i</div>
                    <div class="info-box" style="color: #000000;">
                      {#if find_help_text_if_exists(helptexts, "sales_mirror_herd_coverage")}
                        {@html find_help_text_if_exists(helptexts, "sales_mirror_herd_coverage")}
                      {:else}
                        For all customers: sum of all active animals divided by sum of all herd sizes.
                      {/if}
                      {#if in_show_helptext_id}
                        <div style="font-size: 7px">id: sales_mirror_herd_coverage</div>
                        <div style="font-size: 7px">
                          [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                        </div>
                      {/if}
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <canvas id="gauge_canvas_id" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        &nbsp;<br />
        <h4>My Funnel & Activities</h4>
        <div class="mb-0">
          <span class="text" />
        </div>
      </div>

      <div class="row">
        <div class="col-xl-4 col-xxl-4">
          <div class="row">
            <div class="row">
              <div
                class="card {year_filter == 'ALL' || year_filter.toString() == new Date().getFullYear().toString()
                  ? ''
                  : 'hiddenClassGaunt'}"
              >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 align="center" class="card-title mb-0">
                    Your Funnel<br />current month {#if !isDateWithinLast5Hours(updated_crm_lead)}(last data update: ~{formatDateAndHours(
                        updated_crm_lead
                      )}){/if}
                  </h5>

                  <div class="info-circle my-auto">
                    <div class="my-auto info-i">i</div>
                    <div class="info-box" style="color: #000000;">
                      {#if find_help_text_if_exists(helptexts, "sales_mirror_")}
                        {@html find_help_text_if_exists(helptexts, "sales_mirror_")}
                      {:else}{/if}
                      {#if in_show_helptext_id}
                        <div style="font-size: 7px">id: sales_mirror_</div>
                        <div style="font-size: 7px">
                          [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                        </div>
                      {/if}
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-8">
                      <img class="funnel" src="/static/img/icons/sales_funnel.png" alt="background image" />

                      <p style="color:#4E68A1; font-size:15px;">
                        <b> &nbsp;&nbsp;&nbsp;&nbsp; Average days from creation to won: {opportunities_days_from_create_to_close}</b>
                      </p>
                    </div>
                    <div class="col-4 flex-2">
                      <div class="d-flex flex-2-child"><br /></div>
                      <div class="d-flex flex-2-child">
                        <p style="color:#DE2D2C; font-size:15px;">
                          <b>&nbsp;&nbsp; => &nbsp;&nbsp; {opportunities_in_approach} </b>
                        </p>
                      </div>
                      <div class="d-flex flex-2-child">
                        <p style="color:#FFB339; font-size:15px;">
                          <b>&nbsp;&nbsp; => &nbsp;&nbsp; {opportunities_in_analysis} </b>
                        </p>
                      </div>
                      <div class="d-flex flex-2-child">
                        <p style="color:#4E68A1; font-size:15px;">
                          <b>&nbsp;&nbsp; => &nbsp;&nbsp; {opportunities_in_offers} </b>
                        </p>
                      </div>
                      <div class="d-flex flex-2-child">
                        <p style="color:#27DEF9; font-size:15px;">
                          <b>&nbsp;&nbsp; => &nbsp;&nbsp; {opportunities_in_closing} </b>
                        </p>
                      </div>
                      <div class="d-flex flex-2-child">
                        <p style="color:#9CC927; font-size:15px;"><b> &nbsp;&nbsp;=>&nbsp;&nbsp; {opportunities_in_won} </b></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 class="card-title mb-0">
                    Sum of Opportunities {#if !isDateWithinLast5Hours(updated_crm_lead)}(last data update: ~{formatDateAndHours(
                        updated_crm_lead
                      )}){/if}
                  </h5>
                  {#if table_alltime_open_opportunities}
                    <LineChart dataLine={table_alltime_open_opportunities} />
                  {/if}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 col-xxl-8">
          <div class="row">
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="card-title">
                  <b
                    >Open leads {#if !isDateWithinLast5Hours(updated_crm_lead)}(last data update: ~{formatDateAndHours(
                        updated_crm_lead
                      )}){/if}</b
                  >
                </h5>

                <div class="info-circle my-auto">
                  <div class="my-auto info-i">i</div>
                  <div class="info-box" style="color: #000000;">
                    {#if find_help_text_if_exists(helptexts, "sales_mirror_open_leads")}
                      {@html find_help_text_if_exists(helptexts, "sales_mirror_open_leads")}
                    {:else}
                      Total number of open Leads, use '+' for drilldown
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: sales_mirror_open_leads</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="row">
                  {#if crm_lead_all_filtered}
                    <div class="col-auto">
                      <div class="stat text-primary">
                        <i class="align-middle" data-feather="truck" />
                        {#if leads_offen_table}
                          {leads_offen_table["values"].length}
                        {/if}
                      </div>
                    </div>
                  {/if}
                </div>

                <CollapsibleSection headerText={""}>
                  <div class="content">
                    <div class="row">
                      {#each list_of_sources as ls}
                        <div class="form-group form-check">
                          <input on:change={toggleCheckbox} type="checkbox" checked class="form-check-input {ls}" id={ls} />
                          <label class="form-check-label" for="exampleCheck1">{ls}</label>
                        </div>
                      {/each}

                      <p>&nbsp;</p>
                    </div>

                    <div class="row">
                      {#if leads_offen_table}
                        <Table columns={leads_offen_table["columns"]} data={leads_offen_table["values"]} />
                      {/if}
                    </div>
                  </div>
                </CollapsibleSection>

                <div class="mb-0">
                  <span class="text" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">
                  Conversion {#if !isDateWithinLast5Hours(updated_crm_lead)}(last data update: ~{formatDateAndHours(updated_crm_lead)}){/if}
                </h5>
                <div class="info-circle my-auto">
                  <div class="my-auto info-i">i</div>
                  <div class="info-box" style="color: #000000;">
                    {#if find_help_text_if_exists(helptexts, "sales_mirror_conversion")}
                      {@html find_help_text_if_exists(helptexts, "sales_mirror_conversion")}
                    {:else}
                      Number of converted leads. Does not include lost or archived leads
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: sales_mirror_conversion</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              </div>

              <div class="card-body">
                {#if converted_line_chart}
                  <LineChart dataLine={converted_line_chart} />
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      {#if year_filter == "ALL"}
        <div class="row">
          <div class="col-xl-12 col-xxl-12">
            <div class="chart-container">
              <div class="card h-100">
                <div class="card-header">
                  <div class="balken-title vertical-center">
                    <h5 class="card-title">LEAD CONVERSION</h5>
                  </div>
                </div>
                <div class="card-body card-for-svg">
                  {#if opportunities_lost_sankey_data}
                    <SankeyWrapper data={opportunities_lost_sankey_data} />
                  {/if}
                </div>
                <div class="card-footer text-muted">
                  <div class="row">
                    <div class="col" align="center">
                      <div class="sankeygreendiv" />
                      Lost Rate below average
                    </div>
                  </div>
                  <div class="row">&nbsp;</div>
                  <div class="row">
                    <div class="col" align="center">
                      <div class="sankeyreddiv" />
                      Lost Rate above averag
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/if}

      <div class="row pt-4">
        <div class="col-xl-6 col-xxl-6">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Sales Opportunities {#if !isDateWithinLast5Hours(getEarliestDate( [updated_crm_lead, updated_lost_opportunities, updated_lost_leads] ))}(last
                  data update: ~{formatDateAndHours(
                    getEarliestDate([updated_crm_lead, updated_lost_opportunities, updated_lost_leads])
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_sales_opportunities")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_sales_opportunities")}
                  {:else}
                    new, lost and won
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_sales_opportunities</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if op_chart}
                <LineChart dataLine={op_chart} />
              {/if}
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-xxl-6">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Completed Activities {#if !isDateWithinLast5Hours(updated_mail_activity)}(last data update: ~{formatDateAndHours(
                    updated_mail_activity
                  )}){/if}
              </h5>
              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_completed_activities")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_completed_activities")}
                  {:else}
                    closed opportunities by activity
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_completed_activities</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if activity_chart && new_customer_herdsize_linechart_data}
                <CustomLineChart id={1315} line_data={activity_chart} type={"bar"} bind:salesman_selected bind:redraw />
              {/if}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6 col-xxl-6">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Completed Activities for won Opportunities {#if !isDateWithinLast5Hours(updated_mail_activity)}(last data update: ~{formatDateAndHours(
                    updated_mail_activity
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_completed_activities_won_opportunities")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_completed_activities_won_opportunities")}
                    <br /><br />{:else}{/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_completed_activities_won_opportunities</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if activity_chart_won_opportunities && new_customer_herdsize_linechart_data}
                <CustomLineChart id={1316} line_data={activity_chart_won_opportunities} type={"bar"} bind:salesman_selected bind:redraw />
              {/if}
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-xxl-6">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Completed Activities for lost Opportunities {#if !isDateWithinLast5Hours(updated_mail_activity)}(last data update: ~{formatDateAndHours(
                    updated_mail_activity
                  )}){/if}
              </h5>
              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_completed_activities_lost_opportunities")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_completed_activities_lost_opportunities")}
                    <br /><br />{:else}{/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_completed_activities_lost_opportunities</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if activity_chart_lost_opportunities && new_customer_herdsize_linechart_data}
                <CustomLineChart id={1317} line_data={activity_chart_lost_opportunities} type={"bar"} bind:salesman_selected bind:redraw />
              {/if}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        &nbsp;<br />
        <h4>My Watchlist</h4>
      </div>

      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col mt-0">
                  <SvelteTooltip tip="last 31 days were considered" bottom>
                    <h5 class="card-title"><b>Open Leads (older than 3 days)</b></h5>
                  </SvelteTooltip>
                </div>
                <div class="col-auto" style="margin-right: 20px;">
                  <div class="stat text-primary">
                    <i class="align-middle" data-feather="dollar-sign" />
                    {#if leads_older_three_days_table}
                      {leads_older_three_days_table["values"].length}
                    {/if}
                  </div>
                </div>
              </div>
              <CollapsibleSection headerText={""}>
                <div class="content">
                  <div class="row">
                    {#each list_of_sources as ls}
                      <div class="form-group form-check">
                        <input on:change={toggleCheckbox} type="checkbox" checked class="form-check-input {ls}" id={ls} />
                        <label class="form-check-label" for="exampleCheck1">{ls}</label>
                      </div>
                    {/each}

                    <p>&nbsp;</p>
                  </div>
                  <div class="row">
                    {#if leads_older_three_days_table}
                      <Table columns={leads_older_three_days_table["columns"]} data={leads_older_three_days_table["values"]} />
                    {/if}
                  </div>
                </div>
              </CollapsibleSection>
              <div class="mb-0">
                <span class="text" />
              </div>
            </div>
          </div>
          <div class="help">
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if find_help_text_if_exists(helptexts, "sales_mirror_open_leads_older_3_days")}
                  {@html find_help_text_if_exists(helptexts, "sales_mirror_open_leads_older_3_days")}
                {:else}{/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: sales_mirror_open_leads_older_3_days</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col mt-0">
                  <h5 class="card-title"><b>Opportunities without planned activity</b></h5>
                </div>

                <div class="col-auto" style="margin-right: 20px;">
                  <div class="stat text-primary">
                    <i class="align-middle" data-feather="users" />
                    {opportunities_without_action_count}
                  </div>
                </div>
              </div>

              <CollapsibleSection headerText={""}>
                <div class="content">
                  <div class="row">
                    {#if opportunities_without_action_list_table}
                      <Table
                        columns={["Opportunity", "Customer", "Created", "Stage"]}
                        data={opportunities_without_action_list_table["data"]}
                      />
                    {/if}
                  </div>
                </div></CollapsibleSection
              >
            </div>
          </div>

          <div class="help">
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if find_help_text_if_exists(helptexts, "sales_mirror_opportunities_without_activities")}
                  {@html find_help_text_if_exists(helptexts, "sales_mirror_opportunities_without_activities")}
                {:else}{/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: sales_mirror_opportunities_without_activities</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col mt-0">
                  <h5 class="card-title"><b>Opportunities with overdue activity</b></h5>
                </div>

                <div class="col-auto" style="margin-right: 20px;">
                  <div class="stat text-primary">
                    <i class="align-middle" data-feather="users" />
                    {opportunities_with_overdue_activity_count}
                  </div>
                </div>
              </div>

              <CollapsibleSection headerText={""}>
                <div class="content">
                  <div class="row">
                    {#if opportunities_with_overdue_activity_list_table}
                      <Table
                        columns={["Opportunity", "Customer", "Created", "Stage"]}
                        data={opportunities_with_overdue_activity_list_table["data"]}
                      />
                    {/if}
                  </div>
                </div></CollapsibleSection
              >
            </div>
          </div>

          <div class="help">
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if find_help_text_if_exists(helptexts, "sales_mirror_opportunities_with_overdue_activity")}
                  {@html find_help_text_if_exists(helptexts, "sales_mirror_opportunities_with_overdue_activity")}
                {:else}{/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: sales_mirror_opportunities_with_overdue_activity</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row {year_filter == 'ALL' || year_filter.toString() == new Date().getFullYear().toString() ? '' : 'hiddenClassGaunt'}">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col mt-0">
                  <SvelteTooltip tip="last 31 days were considered" bottom>
                    <h5 class="card-title"><b>Opportunities with closing date in the past</b></h5>
                  </SvelteTooltip>
                </div>

                <div class="col-auto" style="margin-right: 20px;">
                  <div class="stat text-primary">
                    <i class="align-middle" data-feather="shopping-cart" />
                    {opportunities_wit_abschluss_past_count}
                  </div>
                </div>
              </div>
              <CollapsibleSection headerText={""}>
                <div class="content">
                  <div class="row">
                    {#if opportunities_wit_abschluss_past_list_table_data}
                      <Table
                        columns={["Opportunity", "Customer", "Deadline", "Stage"]}
                        data={opportunities_wit_abschluss_past_list_table_data["data"]}
                      />
                    {/if}
                  </div>
                </div></CollapsibleSection
              >
            </div>
          </div>
          <div class="help">
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if find_help_text_if_exists(helptexts, "sales_mirror_opportunities_with_closing_date_in_the_past")}
                  {@html find_help_text_if_exists(helptexts, "sales_mirror_opportunities_with_closing_date_in_the_past")}
                {:else}{/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: sales_mirror_opportunities_with_closing_date_in_the_past</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Cancelled Subscriptions {#if !isDateWithinLast5Hours(updated_sale_subscription)}(last data update: ~{formatDateAndHours(
                    updated_sale_subscription
                  )}){/if}
              </h5>

              <div class="info-circle my-auto">
                <div class="my-auto info-i">i</div>
                <div class="info-box" style="color: #000000;">
                  {#if find_help_text_if_exists(helptexts, "sales_mirror_cancelled_subscriptions")}
                    {@html find_help_text_if_exists(helptexts, "sales_mirror_cancelled_subscriptions")}
                    <br /><br />{:else}{/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: sales_mirror_cancelled_subscriptions</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            </div>

            <div class="card-body">
              {#if subscriptions_cancelled_chart}
                <CustomLineChart id={1317234} line_data={subscriptions_cancelled_chart} bind:redraw bind:salesman_selected />
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      &nbsp;<br />
      <h4>My Customers Map</h4>
    </div>
    <div class="col-xl-3">
      <div class="card {year_filter == 'ALL' || year_filter.toString() == new Date().getFullYear().toString() ? '' : 'hiddenClassGaunt'}">
        <div class="row">
          <div class="card-title d-flex justify-content-between align-items-center">
            <h5 class="card-title">Herd Coverage: {herd_coverage_percentage}%</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if find_help_text_if_exists(helptexts, "sales_mirror_herd_coverage")}
                  {@html find_help_text_if_exists(helptexts, "sales_mirror_herd_coverage")}
                {:else}
                  For all customers: sum of all active animals divided by sum of all herd sizes.
                {/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: sales_mirror_herd_coverage</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>
          <div class="card-body">
            <canvas id="gauge_canvas_id_map" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12 col-xxl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">
              Worldmap {#if !isDateWithinLast5Hours(updated_res_partner)}(last data update: ~{formatDateAndHours(updated_res_partner)}){/if}
            </h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="z-index: 1000; color: #000000;">
                {#if find_help_text_if_exists(helptexts, "sales_mirror_customers_map")}
                  {@html find_help_text_if_exists(helptexts, "sales_mirror_customers_map")}
                {:else}{/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: sales_mirror_customers_map</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>

          <div class="card-body">
            <LeafletWorldMapHeat data={world_map_res_partners} bind:year_filter />
          </div>
        </div>
      </div>
    </div>

    <!-- {#if !no_user_found} -->

    <div class={salesman_selected.length != 1 || salesman_selected[0] == "Others" ? "hiddenClass" : "div"}>
      <div class="row">
        &nbsp;<br />
        <h4>
          Power Chart {#if !isDateWithinLast5Hours(updated_power_chart)}(last data update: ~{formatDateAndHours(updated_power_chart)}){/if}
        </h4>
        <b /><br />&nbsp;
      </div>

      {#if (boli_sold_rank > 0 && boli_sold_rank <= 10) || (first_visit_rank > 0 && first_visit_rank <= 10) || (calls_rank > 0 && calls_rank <= 10)}
        <!-- skip row if no rank was achived -->
        <div class="row">
          <!-- skip if boli sold ranking>11 -->
          {#if boli_sold_rank >= 1 && boli_sold_rank <= 3}
            <div class="col-xl-2 col-xxl-2 d-flex">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 align="center" class="card-title mb-0">Ranking<br />Boli Sold classic</h5>
                  <p align="center">
                    &nbsp;<br />
                    <img src="/static/img/icons/place{boli_sold_rank}.svg" /><br />&nbsp;<br />
                    <b>{boli_sold_rank}. Rank</b><br />
                  </p>
                </div>
              </div>
              <div class="help">
                <a href="#" style="color: gray;" title="You are {boli_sold_rank}. in this months 'Boli Sold classic' ranking!">?</a>
              </div>
            </div>
          {/if}

          {#if boli_sold_rank > 3 && boli_sold_rank <= 10}
            <div class="col-xl-2 col-xxl-2 d-flex">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 align="center" class="card-title mb-0">Ranking<br />Boli Sold classic</h5>
                  <p align="center">
                    &nbsp;<br />
                    <img src="/static/img/icons/place10.svg" /><br />&nbsp;<br />
                    <b>{boli_sold_rank}. Rank</b><br />
                  </p>
                </div>
              </div>
              <div class="help">
                <a href="#" style="color: gray;" title="You are {boli_sold_rank}. in this months 'New Customer Won' ranking!">?</a>
              </div>
            </div>
          {/if}

          {#if first_visit_rank >= 1 && first_visit_rank <= 3}
            <div class="col-xl-2 col-xxl-2 d-flex">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 align="center" class="card-title mb-0">Ranking<br />First Visits</h5>
                  <p align="center">
                    &nbsp;<br />
                    <img src="/static/img/icons/place{first_visit_rank}.svg" /><br />&nbsp;<br />
                    <b>{first_visit_rank}. Rank</b><br />
                  </p>
                </div>
              </div>
              <div class="help">
                <a href="#" style="color: gray;" title="You are {first_visit_rank}. in this months 'Boli Sold classic' ranking!">?</a>
              </div>
            </div>
          {/if}

          {#if first_visit_rank > 3 && first_visit_rank <= 10}
            <div class="col-xl-2 col-xxl-2 d-flex">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 align="center" class="card-title mb-0">Ranking<br />First Visits</h5>
                  <p align="center">
                    &nbsp;<br />
                    <img src="/static/img/icons/place10.svg" /><br />&nbsp;<br />
                    <b>{first_visit_rank}. Rank</b><br />
                  </p>
                </div>
              </div>
              <div class="help">
                <a href="#" style="color: gray;" title="You are {first_visit_rank}. in this months 'New Customer Won' ranking!">?</a>
              </div>
            </div>
          {/if}

          {#if calls_rank >= 1 && calls_rank <= 3}
            <div class="col-xl-2 col-xxl-2 d-flex">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 align="center" class="card-title mb-0">Ranking<br />Calls</h5>
                  <p align="center">
                    &nbsp;<br />
                    <img src="/static/img/icons/place{calls_rank}.svg" /><br />&nbsp;<br />
                    <b>{calls_rank}. Rank</b><br />
                  </p>
                </div>
              </div>
              <div class="help">
                <a href="#" style="color: gray;" title="You are {calls_rank}. in this months 'Boli Sold classic' ranking!">?</a>
              </div>
            </div>
          {/if}

          {#if calls_rank > 3 && calls_rank <= 10}
            <div class="col-xl-2 col-xxl-2 d-flex">
              <div class="card flex-fill">
                <div class="card-header">
                  <h5 align="center" class="card-title mb-0">Ranking<br />Calls</h5>
                  <p align="center">
                    &nbsp;<br />
                    <img src="/static/img/icons/place10.svg" /><br />&nbsp;<br />
                    <b>{calls_rank}. Rank</b><br />
                  </p>
                </div>
              </div>
              <div class="help">
                <a href="#" style="color: gray;" title="You are {calls_rank}. in this months 'New Customer Won' ranking!">?</a>
              </div>
            </div>
          {/if}
        </div>
      {/if}

      <div class="row">
        <div class="col-12 d-flex">
          <div class="card flex-fill">
            <div class="card-header">
              <h5 class="card-title mb-0">Sales Person</h5>
              <Table columns={power_chart_column_names} data={power_chart_table} />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- {/if} -->
  </div>
</main>

<style>
  .card-header {
    padding-bottom: 0px;
  }

  .card-body {
    margin: 0px !important;
    padding: 0px !important;
  }

  .half {
    width: 50px;
  }

  .hiddenClassGaunt {
    visibility: hidden;
    height: 0px;
    overflow: hidden;
  }

  .chart-container {
    width: 100%;
    height: 500px;
  }
  .card-for-svg {
    width: 100%;
    height: 500px;
  }

  .balken-title {
    background-color: #d7e2dc;
    padding-left: 3px;
    padding-top: 3px;
    padding-bottom: 0px;
  }

  .vertical-center {
    display: flex;
    align-items: center;
  }

  .hiddenClass {
    visibility: hidden;
    display: none;
  }

  .hiddenClassRow {
    /*visibility: hidden;
    display: none;
    opacity:  0;
    transition: visibility 2s, opacity 2s linear;*/

    max-height: 0;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    transition: max-height 0.5s ease-in;
  }

  .shownClassRow {
    max-height: auto;

    opacity: 1;
    transition: max-height 0.5s ease-in;
    transition: opacity 0.5s ease-in;
  }

  .help {
    position: absolute;
    right: 0;
    top: 0;
    width: 22px;
    height: 15px;
    z-index: 100;
  }
  .funnel {
    max-width: 100%;
  }

  .funnelParentNumbers {
    display: flex;
    flex-direction: column;
  }

  .flex-2 {
    position: relative;
    flex: 1;
  }
  .flex-2-child {
    display: flex;
    align-items: stretch;
    height: 16.8%;
  }

  .gauge_boli {
    width: 100%;
  }

  #sold_more_then_boli {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #current_boli {
    width: 50px;
    height: 20px;
    background: #fff04d;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #should_be_here {
    width: 50px;
    height: 20px;
    background: #03fcf4;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .reddiv {
    width: 50px;
    height: 20px;
    background: #990e05;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .greendiv {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .active {
    color: #333;
    border-color: #325cff;
  }

  .sankeygreendiv {
    width: 50px;
    height: 20px;
    background: #25ff37;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .sankeyreddiv {
    width: 50px;
    height: 20px;
    background: #8d1111;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .maus:hover {
    cursor: pointer;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    left: 200px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 35px;
    right: 35px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
